// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-03T18:34:31.169Z
// Property: Watercrest (ID: 6767906449167098)
// Collections: 29 amenities, 8 floorplans (live), 22 photos, 38 POIs, 5 reviews, 4 virtual tours, 5 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5726763346821120",
  "multihub_property_id": "6767906449167098",
  "property_external_id": "1021916",
  "property_zillow_url": "https://www.zillow.com/apartments/lake-forest-park-wa/watercrest/5hJ4bt/",
  "property_apartments_url": "https://www.apartments.com/watercrest-lake-forest-park-wa/v0qkpyg/",
  "property_google_business_url": "https://www.google.com/maps/place/Watercrest/data=!4m2!3m1!1s0x0:0x53514556027ffa54?sa=X&ved=2ahUKEwi75qjEvYOTAxX7jokEHdcNAXsQ_BJ6BAgYEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "2429280200",
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "watercrest",
  "property_name": "Watercrest",
  "property_website_url": "https://www.watercrestapartments.com",
  "property_domain": "https://www.watercrestapartments.com",
  "property_address": "14812 Bothell Way NE",
  "property_full_address": "14812 Bothell Way NE, Lake Forest Park, WA, 98155",
  "property_address_1": "14812 Bothell Way NE",
  "property_address_2": null,
  "property_address_city": "Lake Forest Park",
  "property_address_state": "WA",
  "property_address_zip_full": "98155",
  "property_address_zip": "98155",
  "property_address_country": "US",
  "property_address_county": "King",
  "property_neighborhood_address": "Sheridan Beach",
  "property_address_latitude": "47.736861",
  "property_address_longitude": "-122.291243",
  "property_email": "watercrest@weidner.com",
  "property_phone": "2064017623",
  "property_call_tracking_phone": "206-709-5440",
  "property_company_name": "Weidner Apartment Homes",
  "property_company_url": "https://www.weidner.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Embrace lakeside living at Watercrest, where comfort meets convenience in our diverse floor plans, including studios to spacious three-bedroom homes. Enjoy premium amenities like a refreshing pool, fitness center, and scenic picnic areas. Your perfect home awaits—check availability or schedule a tour today and experience the Watercrest lifestyle!",
  "property_long_description": "Welcome to Watercrest, your serene sanctuary nestled in the heart of Lake Forest Park, WA. Our vibrant apartment community offers a diverse range of floor plans, featuring modern Studio, One Bedroom, Two Bedroom, and spacious Three Bedroom options that cater to every lifestyle. With a focus on comfort and convenience, you'll find all the amenities you need right at your fingertips.\n\nExperience stress-free living with our dedicated on-site management and maintenance teams, ensuring that your home remains a haven of tranquility. Enjoy eco-friendly practices with our recycling program, while curbside trash pickup and laundry facilities make daily tasks effortless. \n\nStep outside to explore our beautifully landscaped courtyard, picnic, and grill areas, perfect for gatherings with friends and family. Unwind after a long day in our sauna or dive into the sparkling pool, surrounded by inviting waterfront views. For fitness enthusiasts, our state-of-the-art fitness center is equipped with cardio machines and free weights to help you stay active.\n\nEach apartment is designed for maximum comfort, featuring ceiling fans, spacious closets, and private patios or balconies to enjoy the scenic surroundings. Our smoke-free community provides a breath of fresh air, with controlled access for your peace of mind.\n\nReady to elevate your lifestyle? Find your new home today at Watercrest! Browse our availability or schedule a tour to visit our welcoming community and discover why you'll want to make Watercrest your new home.",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167098/019d0211-5aaf-7684-8a43-67be043c8d22.webp",
  "property_featured_image_media": {
    "alt_text": "Apartment building exterior with manicured lawns and trees.",
    "public_id": "019d0211-5aaf-7684-8a43-67be043c8d22",
    "storage_key": "property/6767906449167098/019d0211-5aaf-7684-8a43-67be043c8d22.webp",
    "width": 2560,
    "height": 936
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "175",
  "property_year_built": "1968",
  "property_year_renovated": null,
  "property_walk_score": "66",
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "94.28571428571428",
  "property_admin_fee": null,
  "property_application_fee": "28",
  "property_fees_deposit_info": "600",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "Varies",
  "property_pet_deposit": "300",
  "property_monthly_pet_rent": "50",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "100",
  "property_pet_restrictions": "Breed restrictions apply",
  "property_pet_policy_description": "Up to 2 pets per home are welcome.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://watercrestapartments.securecafe.com/onlineleasing/watercrest-1/floorplans.aspx",
  "property_resident_portal_url": "https://watercrestapartments.securecafenet.com/residentservices/watercrest-1/userlogin",
  "property_apply_now_url": "https://watercrestapartments.securecafe.com/onlineleasing/watercrest-1/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167098/019d0211-680d-7176-84e5-378a25f585b2.webp",
  "property_primary_logo_media": {
    "alt_text": "Black screen",
    "public_id": "019d0211-680d-7176-84e5-378a25f585b2",
    "storage_key": "property/6767906449167098/019d0211-680d-7176-84e5-378a25f585b2.webp",
    "width": 230,
    "height": 75
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167098/019d0211-7738-712f-b783-1628e2b3b2dc.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Watercrest Apartments logo",
    "public_id": "019d0211-7738-712f-b783-1628e2b3b2dc",
    "storage_key": "property/6767906449167098/019d0211-7738-712f-b783-1628e2b3b2dc.webp",
    "width": 230,
    "height": 75
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167098/019d0211-8170-724b-aab9-63f88296fe52.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Watercrest Apartments logo",
    "public_id": "019d0211-8170-724b-aab9-63f88296fe52",
    "storage_key": "property/6767906449167098/019d0211-8170-724b-aab9-63f88296fe52.webp",
    "width": 230,
    "height": 75
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-4291-7593-82c0-efd4c864db24.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
  "property_company_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d0198-5322-7081-947b-e809ba802b6c",
    "storage_key": "company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
    "width": 1342,
    "height": 402
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-bdc5-779e-a400-a391326cc801",
    "storage_key": "company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
    "width": 640,
    "height": 192
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-c548-748f-97de-b042810ed358",
    "storage_key": "company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
    "width": 640,
    "height": 192
  },
  "property_primary_color": "#cc5f1c",
  "property_secondary_color": "#b2bacc",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "studio - 3",
  "property_bedrooms_min": "studio",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": " - 1394",
  "property_sqft_min": "720",
  "property_sqft_max": "1394",
  "property_price_range": "1629 - 3219",
  "property_price_min": "1629",
  "property_price_max": "3219",
  "property_available_units": 10,
  "property_facebook_url": "https://www.facebook.com/WatercrestApartments",
  "property_instagram_url": null,
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJzfG94KERkFQRVPp_AlZFUVM",
  "property_youtube_url": "https://www.youtube.com/@WeidnerApartmentHomes",
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Watercrest",
  "property_home_romance_title": "Embrace Your Dream Life in Our Charming Apartment Community",
  "property_home_amenities_blurb": "Welcome home to Watercrest, where comfortable living meets a vibrant lifestyle in Lake Forest Park, WA. Choose from thoughtfully designed studio to three-bedroom floor plans, and enjoy amenities like a serene waterfront, fitness center, and inviting picnic areas. Embrace the perfect blend of convenience and community today!",
  "property_home_floorplans_blurb": "At Watercrest in Lake Forest Park, WA, your ideal home awaits. With an array of thoughtfully designed floor plans, each space reflects modern living while embracing natural beauty. Immerse yourself in comfort and style—browse our available apartment homes today to discover the perfect fit for your unique lifestyle.",
  "property_home_gallery_blurb": "Nestled in the heart of Lake Forest Park, Watercrest offers a variety of thoughtfully designed floor plans, from cozy studios to spacious three-bedroom apartments. Enjoy unparalleled amenities like a sparkling pool, fitness center, and serene waterfront views. Picture yourself living here—an oasis where comfort meets convenience!",
  "property_home_neighborhood_blurb": "Welcome to Watercrest, your serene Lake Forest Park retreat! Enjoy thoughtfully designed studio to three-bedroom apartments, just moments from the lush greenery of Golden Gardens Park and the cultural treasures at the Burke Museum. Dive into a vibrant lifestyle surrounded by education, recreation, and community. Uncover your perfect fit today!",
  "property_home_reviews_blurb": "Nestled in the picturesque Lake Forest Park, Watercrest offers residents a serene living experience. With smiles all around, one resident raves, \"The community is welcoming, and the amenities are top-notch.\" Curious about life at Watercrest? See what our residents have to say about living at our vibrant community!",
  "property_neighborhood_blurb": "Welcome to Watercrest, where Lake Forest Park’s vibrant community awaits. Just moments away, immerse yourself in cultural treasures like the Burke Museum and Henry Art Gallery, enjoy the serenity of Golden Gardens Park, and connect with nature at Woodland Park Zoo. See what’s around our community and discover local favorites!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Watercrest in Lake Forest Park, WA, embrace lakeside living with a spectrum of floor plans—from cozy studios to spacious three-bedrooms. Enjoy top-tier amenities like a serene sauna, state-of-the-art fitness center, and scenic picnic spots. Elevate your lifestyle by joining our vibrant community today and savor every moment!",
  "property_applynow_blurb": "At Watercrest in Lake Forest Park, WA, your ideal home awaits. Choose from spacious studios to three-bedroom layouts, complete with modern amenities like a fitness center, serene courtyard, and waterfront views. Embrace comfort and convenience—take the first step toward a vibrant lifestyle by leasing online today!",
  "property_contactus_blurb": "At Watercrest in Lake Forest Park, WA, we offer a variety of living spaces—from inviting studios to spacious three-bedroom layouts. Tailor your lifestyle in our thoughtfully designed floor plans that cater to all needs. Have questions? Contact our leasing team today to find your perfect home!",
  "property_faqs_blurb": "At Watercrest in Lake Forest Park, WA, we offer versatile floor plans, from cozy studios to spacious three-bedroom apartments. Have questions about our vibrant community? Unlock essential insights and details by visiting our FAQs page, where answers await to help you make the perfect choice for your new home.",
  "property_floorplans_blurb": "At Watercrest in Lake Forest Park, WA, you'll find a variety of thoughtfully designed floor plans to suit your lifestyle—from cozy studios to spacious three-bedroom apartments. Each layout offers modern amenities and inviting spaces. Browse our available homes today and envision your ideal living environment by the water.",
  "property_gallery_blurb": "At Watercrest in Lake Forest Park, WA, stunning photo galleries capture the essence of lakeside living. Envision your future in our thoughtfully designed studio to three-bedroom apartments, complemented by amenities like a tranquil sauna, fitness center, and BBQ areas. Picture yourself thriving in this vibrant, smoke-free community!",
  "property_interactivemap_blurb": "Welcome to Watercrest in Lake Forest Park, WA, where comfort meets convenience. Choose from a variety of thoughtfully designed floor plans, from cozy studios to spacious three-bedrooms. Enjoy exceptional amenities like a refreshing pool, fitness center, and serene waterfront views. Use our interactive map to find your perfect home today!",
  "property_pets_blurb": "At Watercrest in Lake Forest Park, WA, your furry friends are a cherished part of the community. With spacious apartments and lush surroundings, you and your pets will thrive. Bring up to two dogs or cats, up to 100 lbs each, and enjoy a vibrant lifestyle surrounded by nature.",
  "property_referafriend_blurb": "At Watercrest in Lake Forest Park, WA, a vibrant community thrives in diverse floor plans, from cozy studios to spacious three-bedrooms. Great friends make great neighbors—refer a friend today and let them join the exceptional lifestyle waiting for you here. Together, make memories in your new home!",
  "property_residentaccess_blurb": "Welcome to Watercrest in scenic Lake Forest Park, WA, where comfort meets convenience. Whether you choose a cozy studio or a spacious three-bedroom, your ideal floor plan awaits. Log in to your resident portal for easy rent payments, maintenance requests, and enhanced living—your peaceful retreat is just a click away!",
  "property_reviews_blurb": "At Watercrest in Lake Forest Park, WA, our residents rave about their experience: \"The atmosphere here is friendly and welcoming!\" Check out the heartfelt testimonials that highlight the vibrant community and unmatched amenities. Ready to see why everyone loves calling Watercrest home? Visit our reviews page today!",
  "property_created_at": "1771527439768",
  "property_scheduletour_blurb": "Nestled in the serene surroundings of Lake Forest Park, WA, Watercrest offers an array of thoughtfully designed floor plans from cozy studios to spacious three-bedroom apartments. Experience the perfect blend of comfort and community. Ready to envision your new home? Schedule a tour and hear from our satisfied residents!",
  "property_thankyou_blurb": "Thank you for reaching out to Watercrest! Nestled in the serene Lake Forest Park, our diverse floor plans—from cozy studios to spacious three-bedrooms—offer the perfect home for every lifestyle. A team member will connect with you soon to discuss your ideal living experience. ",
  "property_virtualtours_blurb": "At Watercrest in Lake Forest Park, WA, each thoughtfully designed floor plan, from cozy studios to spacious three-bedroom apartments, is tailored for your lifestyle. Experience the charm of our community—take a virtual tour today and imagine your future home in this serene, inviting oasis!",
  "property_copyright": "2026 All Rights Reserved. Watercrest",
  "property_seo_title_home": "Watercrest |  Apartments in Lake Forest Park, WA",
  "property_seo_description_home": "Experience Lake Forest Park living at Watercrest! With spacious studios to three-bedroom apartments, top-notch amenities await. Your new home is calling!",
  "property_seo_title_floorplans": "Floor Plans | Lake Forest Park, WA Apartments for Rent",
  "property_seo_description_floorplans": "Uncover the ideal space for your lifestyle at Watercrest in Lake Forest Park. From cozy studios to spacious three-bedrooms, your perfect home awaits!",
  "property_seo_title_amenities": "Amenities | Lake Forest Park, WA Apartments for Rent",
  "property_seo_description_amenities": "Unwind at Watercrest in Lake Forest Park! Enjoy spacious floor plans, waterfront views, a fitness center, pool, and lush courtyards. Live your best life today!",
  "property_seo_title_gallery": "Gallery | Apartments in Lake Forest Park, WA",
  "property_seo_description_gallery": "Unwind at Watercrest in Lake Forest Park, WA! Enjoy stunning views, top-notch amenities, and diverse floor plans. Picture your dream life by the water.",
  "property_seo_title_virtualtours": "Virtual Tours | Watercrest Apartments",
  "property_seo_description_virtualtours": "Experience Watercrest in Lake Forest Park, WA! Immerse yourself in our stunning studio to three-bedroom apartments through an engaging virtual tour today!",
  "property_seo_title_interactivemap": "Interactive Map | Watercrest Apartments",
  "property_seo_description_interactivemap": "Find your perfect apartment at Watercrest in Lake Forest Park! Enjoy waterfront views, modern amenities, and an interactive map to explore your future home.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Lake Forest Park, WA",
  "property_seo_description_neighborhood": "Experience life at Watercrest in Lake Forest Park, WA! Discover local favorites and hidden gems just steps from our vibrant community. Join us today!",
  "property_seo_title_contact": "Contact Us | Watercrest",
  "property_seo_description_contact": "Experience Lake Forest Park living at Watercrest! Choose from studio to three-bedroom floor plans. Have questions? Reach out to our leasing team today!",
  "property_seo_title_faqs": "FAQs | Apartments in Lake Forest Park, WA",
  "property_seo_description_faqs": "Your ideal home awaits at Watercrest in Lake Forest Park! Browse our FAQs for insights on amenities, floor plans, and what makes our community unique.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Lake Forest Park, WA",
  "property_seo_description_reviews": "Join the Watercrest community in Lake Forest Park, WA! Explore resident reviews for the perfect blend of comfort and serene waterfront living.",
  "property_seo_title_applynow": "Apply Now | Apartments in Lake Forest Park, WA",
  "property_seo_description_applynow": "Experience lakeside living at Watercrest in Lake Forest Park—modern studios to spacious three-bedrooms, plus exceptional amenities. Your dream home awaits!",
  "property_seo_title_residentaccess": "Resident Access | Watercrest",
  "property_seo_description_residentaccess": "Unlock convenience at Watercrest in Lake Forest Park, WA. Access your resident portal for easy rent payments, maintenance requests, and more today!",
  "property_seo_title_referafriend": "Refer A Friend | Watercrest",
  "property_seo_description_referafriend": "Refer a friend to Watercrest in Lake Forest Park, WA, and enjoy a vibrant community and shared living experience together!",
  "property_seo_title_scheduletour": "Schedule a Tour | Watercrest",
  "property_seo_description_scheduletour": "Experience the charm of Watercrest in Lake Forest Park, WA. Schedule a tour today and envision your new life in our vibrant community!",
  "property_seo_title_privacy": "Privacy Policy | Watercrest",
  "property_seo_description_privacy": "At Watercrest in Lake Forest Park, your privacy matters. Discover how we protect your information. Check our privacy policy today!",
  "property_seo_title_accessibility": "Website Accessibility | Watercrest",
  "property_seo_description_accessibility": "At Watercrest in Lake Forest Park, WA, we prioritize digital accessibility for all. Join our inclusive community where everyone feels at home online!",
  "property_seo_title_sitemap": "Sitemap | Watercrest",
  "property_seo_description_sitemap": "Navigate the serene life at Watercrest in Lake Forest Park, WA. Check our sitemap to find your dream apartment and embrace tranquility today!",
  "property_seo_title_thankyou": "Thank You | Watercrest",
  "property_seo_description_thankyou": "Thanks for reaching out to Watercrest! Your inquiry is important to us. Expect a team member to connect with you soon about your Lake Forest Park future!",
  "property_seo_title_pets": "Pet Policy | Apartments in Lake Forest Park, WA",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1793119463073",
  "amenities": [
    {
      "id": "ec_b91a7c7cb01fa3e696ec8d9e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "source": "yardi",
      "external_id": "86898387",
      "title": "On-site Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e6c3a795123eec7defcee344",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "source": "yardi",
      "external_id": "86898388",
      "title": "On-site Management",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4bac6c8df6d7ee15d2be5f40",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "source": "yardi",
      "external_id": "86898389",
      "title": "Recycling",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_253bd839baf11d6efd25582b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "source": "yardi",
      "external_id": "86898392",
      "title": "Elevator",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e855c0dcde0880bf6e655a20",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "source": "yardi",
      "external_id": "86898393",
      "title": "Laundry Facilities/Laundry Room",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_dc80d40c9c68a10a6ccfdd44",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "source": "yardi",
      "external_id": "86898394",
      "title": "Sauna",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167098/019d020f-68d9-7579-a1c4-9e7bede4f865.webp",
      "amenity_image_media": {
        "alt_text": "Wooden sauna with tiered benches and a heater.",
        "public_id": "019d020f-68d9-7579-a1c4-9e7bede4f865",
        "storage_key": "property/6767906449167098/019d020f-68d9-7579-a1c4-9e7bede4f865.webp",
        "width": 1024,
        "height": 683
      },
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_145f4a153d3376e3090b84e0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "source": "yardi",
      "external_id": "86898396",
      "title": "Courtyard",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167098/01a035aa-f475-711f-99ee-c53c5163aa1e.webp",
      "amenity_image_media": {
        "alt_text": "Exterior view of apartment buildings with manicured lawns and trees under a blue sky.",
        "public_id": "01a035aa-f475-711f-99ee-c53c5163aa1e",
        "storage_key": "property/6767906449167098/01a035aa-f475-711f-99ee-c53c5163aa1e.webp",
        "width": 1024,
        "height": 683
      },
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a3a974591321ad16233ffa01",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "source": "yardi",
      "external_id": "86898397",
      "title": "Picnic Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_89ef7357370eef1de697075c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "source": "yardi",
      "external_id": "86898400",
      "title": "Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167098/019d9a43-faee-70ef-baa2-6f81b86febed.webp",
      "amenity_image_media": {
        "alt_text": "Fitness center with treadmills, recumbent bikes, and weight machines.",
        "public_id": "019d9a43-faee-70ef-baa2-6f81b86febed",
        "storage_key": "property/6767906449167098/019d9a43-faee-70ef-baa2-6f81b86febed.webp",
        "width": 1024,
        "height": 683
      },
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_223ca9402b99e306e686dd40",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "source": "yardi",
      "external_id": "86898401",
      "title": "Free Weights",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8422a482b6e76249df94d034",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "source": "yardi",
      "external_id": "86898402",
      "title": "Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167098/019d9a43-fb8e-7039-a110-cc5bf63a1f3b.webp",
      "amenity_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and tables, surrounded by apartment buildings.",
        "public_id": "019d9a43-fb8e-7039-a110-cc5bf63a1f3b",
        "storage_key": "property/6767906449167098/019d9a43-fb8e-7039-a110-cc5bf63a1f3b.webp",
        "width": 1024,
        "height": 683
      },
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_470b845c4daf62cd4e3f18c0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "source": "yardi",
      "external_id": "86898405",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167098/019d020f-4810-776f-94b9-d15670194a1a.webp",
      "amenity_image_media": {
        "alt_text": "Kitchen with white cabinets, a stainless steel sink, and a white stove and refrigerator.",
        "public_id": "019d020f-4810-776f-94b9-d15670194a1a",
        "storage_key": "property/6767906449167098/019d020f-4810-776f-94b9-d15670194a1a.webp",
        "width": 1024,
        "height": 683
      },
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e9d121ef53fbbdd62794cfc1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "source": "yardi",
      "external_id": "86898408",
      "title": "Ceiling Fans",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d5c61f096ed40fbe959bf85f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "source": "yardi",
      "external_id": "86898409",
      "title": "Patio/Balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167098/019d020f-72c8-774a-ac25-28cd714a2cba.webp",
      "amenity_image_media": {
        "alt_text": "Balcony with a scenic water view.",
        "public_id": "019d020f-72c8-774a-ac25-28cd714a2cba",
        "storage_key": "property/6767906449167098/019d020f-72c8-774a-ac25-28cd714a2cba.webp",
        "width": 1500,
        "height": 1125
      },
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7647d3f08b9cb1b948429705",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "source": "yardi",
      "external_id": "86898410",
      "title": "Views",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_47e8dea848bf120598504a2f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "source": "yardi",
      "external_id": "86898395",
      "title": "Disposal Chutes",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9f6ff4458594bd9ff85d5dea",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "source": "yardi",
      "external_id": "86898414",
      "title": "Linen Closet",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5ff6eb8156d741e82d7360b7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "source": "yardi",
      "external_id": "86898407",
      "title": "Baseboard Heat",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f05727e2798f8db5fa27449f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "source": "yardi",
      "external_id": "86898390",
      "title": "Trash Pickup - Curbside",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_123bcb50bd30b06e391225c9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "source": "yardi",
      "external_id": "86898412",
      "title": "Dining Room",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f78c9aae0a3b4e6d7ccc5b09",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "source": "yardi",
      "external_id": "86898413",
      "title": "Intercom/Call Box",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1491b4628b1acbb6a4f285d9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "source": "yardi",
      "external_id": "86898416",
      "title": "Large Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167098/019d020f-adbd-73ac-a9d5-3b9089333044.webp",
      "amenity_image_media": {
        "alt_text": "Empty apartment bedroom with two closets",
        "public_id": "019d020f-adbd-73ac-a9d5-3b9089333044",
        "storage_key": "property/6767906449167098/019d020f-adbd-73ac-a9d5-3b9089333044.webp",
        "width": 1024,
        "height": 683
      },
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a3fa50942580f793ad4009f7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "source": "yardi",
      "external_id": "86898398",
      "title": "Barbecue/Grill Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167098/019d020f-6ea7-756a-8dc0-6453ab5d0506.webp",
      "amenity_image_media": {
        "alt_text": "Outdoor swimming pool area with picnic table and barbecue grill.",
        "public_id": "019d020f-6ea7-756a-8dc0-6453ab5d0506",
        "storage_key": "property/6767906449167098/019d020f-6ea7-756a-8dc0-6453ab5d0506.webp",
        "width": 1024,
        "height": 683
      },
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_87362ba871f34071942bbbe8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "source": "yardi",
      "external_id": "86898399",
      "title": "Views of Water",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_78bf4b2d4c78832fbf341759",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "source": "yardi",
      "external_id": "122026447",
      "title": "Controlled Access",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_35204f6f7502c84ccffcabfd",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "source": "yardi",
      "external_id": "86898403",
      "title": "Cardio Machines",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7bdf24be12dcf74b343c08fa",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "source": "yardi",
      "external_id": "124800127",
      "title": "Smoke Free",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fccf28a452e167f07d0a7df4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "source": "yardi",
      "external_id": "86898404",
      "title": "Weight Machines",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7ef87eb74678a0adf404fbe4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "source": "yardi",
      "external_id": "126979615",
      "title": "View Courtyard",
      "amount": "false",
      "description": "View Courtyard",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_1765be3c99f125aae1df56e9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167098/01a035a9-a6f9-76bf-8605-4c6374491011.webp",
      "image_media": {
        "alt_text": "Watercrest Apartment Homes signage",
        "public_id": "01a035a9-a6f9-76bf-8605-4c6374491011",
        "storage_key": "property/6767906449167098/01a035a9-a6f9-76bf-8605-4c6374491011.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to Watercrest Apartment Homes, with community address 14812.",
      "link": "false",
      "alt_text": "An inviting community entrance sign here at Watercrest featuring a bold orange monument sign, landscaped rock garden with greenery, and a clean driveway leading toward attractive residential buildings under a bright blue sky.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Watercrest_Favorites%20(38).jpg"
    },
    {
      "id": "ec_3e055f8992ffba3c732658cb",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167098/01a11a1c-db52-75fe-8d51-a808f9abf4ef.webp",
      "image_media": {
        "alt_text": "Watercrest Apartments exterior with promotional text 'Up to one month FREE on select homes'.",
        "public_id": "01a11a1c-db52-75fe-8d51-a808f9abf4ef",
        "storage_key": "property/6767906449167098/01a11a1c-db52-75fe-8d51-a808f9abf4ef.webp",
        "width": 2000,
        "height": 1294
      },
      "title": "Community",
      "description": "Exterior view of Watercrest Apartments featuring lush landscaping and a promotional banner advertising 'Up to one month FREE on select homes'.",
      "link": "false",
      "alt_text": "A promotional image for Watercrest Apartments offering up to one month free on select homes.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/10335%20-%20Watercrest%20-%20WA%20(1)%20(1).png"
    },
    {
      "id": "ec_8011bcf1eb8ae253c91cc307",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167098/01a035a9-cac1-760b-b65c-eb21d1b00aa5.webp",
      "image_media": {
        "alt_text": "Apartment buildings surrounded by lush green lawns, trees, and landscaping under a blue sky with clouds.",
        "public_id": "01a035a9-cac1-760b-b65c-eb21d1b00aa5",
        "storage_key": "property/6767906449167098/01a035a9-cac1-760b-b65c-eb21d1b00aa5.webp",
        "width": 2560,
        "height": 1707
      },
      "title": "Community",
      "description": "Experience comfortable living in this serene community, featuring beautifully maintained grounds with ample green space and mature trees.",
      "link": "false",
      "alt_text": "A beautiful exterior here at Watercrest with lush green lawns, landscaped trees, and a paved walking path, leading to well-maintained apartment buildings with private balconies, creating a peaceful and park-like community setting.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Watercrest_Favorites%20(19)_websize.jpg"
    },
    {
      "id": "ec_a7469ae28b004ff7c2388f51",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167098/01a035a9-c890-74c6-8961-9a1e1a88e5cd.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs, picnic table, and gas grill.",
        "public_id": "01a035a9-c890-74c6-8961-9a1e1a88e5cd",
        "storage_key": "property/6767906449167098/01a035a9-c890-74c6-8961-9a1e1a88e5cd.webp",
        "width": 2560,
        "height": 1707
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim in the outdoor pool, relax on a lounge chair, or host a BBQ with friends and family using the provided gas grill and picnic table.",
      "link": "false",
      "alt_text": "A welcoming outdoor grilling area here at Watercrest with a barbecue grill, picnic table seating, and views of the community swimming pool, creating a perfect space for relaxing and outdoor gatherings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Watercrest_Favorites%20(16)_websize.jpg"
    },
    {
      "id": "ec_6ce7fad51c4643c0bd366e9a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167098/01a035a9-e2e8-720e-9ca1-9871a2eb3dbb.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings with a lake and treed hills in the background.",
        "public_id": "01a035a9-e2e8-720e-9ca1-9871a2eb3dbb",
        "storage_key": "property/6767906449167098/01a035a9-e2e8-720e-9ca1-9871a2eb3dbb.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Community",
      "description": "Discover comfortable living in these apartment buildings, set against a backdrop of a serene lake and lush green hills.",
      "link": "false",
      "alt_text": "A scenic aerial view here at Watercrest showcasing well-maintained apartment buildings, landscaped grounds, and ample parking, set near a beautiful waterfront with expansive water and tree-lined views, creating a peaceful and desirable location.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Watercrest_Favorites%20(25).jpg"
    },
    {
      "id": "ec_8d7800d90922ba2ca8aac7b7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167098/01a035a9-e2fb-75ec-9eeb-0b9b624b1813.webp",
      "image_media": {
        "alt_text": "Apartment building exterior with covered parking and balconies.",
        "public_id": "01a035a9-e2fb-75ec-9eeb-0b9b624b1813",
        "storage_key": "property/6767906449167098/01a035a9-e2fb-75ec-9eeb-0b9b624b1813.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Modern apartment building featuring covered parking, private balconies, and an attractive orange and wood exterior.",
      "link": "false",
      "alt_text": "A well-maintained exterior here at Watercrest with covered parking spaces beneath the apartment building, featuring private balconies above and a clean paved driveway, creating a convenient and welcoming residential setting.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Watercrest_Favorites%20(39).jpg"
    },
    {
      "id": "ec_db840777a04cf934aab43392",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167098/01a035a9-d9b9-70c6-9e43-b2cf9a143dde.webp",
      "image_media": {
        "alt_text": "Balcony with a view of a lake and trees",
        "public_id": "01a035a9-d9b9-70c6-9e43-b2cf9a143dde",
        "storage_key": "property/6767906449167098/01a035a9-d9b9-70c6-9e43-b2cf9a143dde.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Apartment",
      "description": "Enjoy your morning coffee or evening relaxation on this spacious balcony with a beautiful view of the lake and surrounding greenery.",
      "link": "false",
      "alt_text": "A private covered balcony here at Watercrest with a spacious floor area and sturdy railing, offering scenic views of surrounding trees and water, creating a peaceful and relaxing outdoor retreat.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Watercrest_Favorites%20(31).jpg"
    },
    {
      "id": "ec_94e63e8633b4525b9c8922c2",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167098/01a035a9-fa5f-71cb-92b3-65b7243c0e31.webp",
      "image_media": {
        "alt_text": "Swimming pool with lounge chairs and an umbrella-covered table.",
        "public_id": "01a035a9-fa5f-71cb-92b3-65b7243c0e31",
        "storage_key": "property/6767906449167098/01a035a9-fa5f-71cb-92b3-65b7243c0e31.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by comfortable lounge chairs for ultimate relaxation.",
      "link": "false",
      "alt_text": "A refreshing outdoor swimming pool here at Watercrest with clear blue water, surrounding lounge chairs, and shaded seating areas, creating a relaxing and enjoyable community space under a bright open sky.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Watercrest_Favorites%20(33).jpg"
    },
    {
      "id": "ec_4bf05f9093fed839769643d8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167098/01a035a9-f7af-772e-b81a-e4ff3a206899.webp",
      "image_media": {
        "alt_text": "Lobby seating area with fireplace and artwork.",
        "public_id": "01a035a9-f7af-772e-b81a-e4ff3a206899",
        "storage_key": "property/6767906449167098/01a035a9-f7af-772e-b81a-e4ff3a206899.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish lobby, featuring comfortable seating, a decorative fireplace, and modern artwork.",
      "link": "false",
      "alt_text": "A stylish resident lounge here at Watercrest with modern seating, patterned carpet, and a decorative fireplace, featuring warm accent lighting and contemporary décor, creating a comfortable and inviting community gathering space.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Watercrest_Favorites%20(30).jpg"
    },
    {
      "id": "ec_ff1459bdf4ac93507de2fe7d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167098/01a035aa-1143-7458-ad31-6e16f4a83337.webp",
      "image_media": {
        "alt_text": "Interior of a wooden sauna with benches and a heater.",
        "public_id": "01a035aa-1143-7458-ad31-6e16f4a83337",
        "storage_key": "property/6767906449167098/01a035aa-1143-7458-ad31-6e16f4a83337.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in our community sauna, featuring natural wood finishes and comfortable seating.",
      "link": "false",
      "alt_text": "A relaxing sauna here at Watercrest with warm wood-paneled walls and tiered bench seating, offering a peaceful and rejuvenating community amenity for resident wellness.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Watercrest_Favorites%20(27).jpg"
    },
    {
      "id": "ec_d971c91650c19a3bef8664c5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167098/01a035aa-23cd-735f-b8a9-d049dfc5d542.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, ellipticals, stationary bikes, and weight machines.",
        "public_id": "01a035aa-23cd-735f-b8a9-d049dfc5d542",
        "storage_key": "property/6767906449167098/01a035aa-23cd-735f-b8a9-d049dfc5d542.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active in our fully equipped fitness center, featuring cardio machines and strength training equipment.",
      "link": "false",
      "alt_text": "A well-equipped fitness center here at Watercrest with cardio machines, strength equipment, and free weights, featuring mirrored walls and bright lighting, creating a convenient and motivating space for resident workouts.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Watercrest_Favorites%20(35).jpg"
    },
    {
      "id": "ec_a5bffadda4738612237373e5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167098/01a035aa-3008-751b-b280-3da30709f999.webp",
      "image_media": {
        "alt_text": "View of apartment interior with sliding glass doors leading to a patio, showing kitchen and living area.",
        "public_id": "01a035aa-3008-751b-b280-3da30709f999",
        "storage_key": "property/6767906449167098/01a035aa-3008-751b-b280-3da30709f999.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Step outside onto your private patio or balcony, accessible through sliding glass doors. Enjoy a breath of fresh air before heading into your spacious apartment, which includes a well-appointed kitchen and comfortable living area.",
      "link": "false",
      "alt_text": "A private covered balcony here at Watercrest with a wood-paneled ceiling and spacious floor area, featuring sliding glass doors and large windows that provide easy access and views into the bright interior living spaces.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Watercrest_Favorites%20(37).jpg"
    },
    {
      "id": "ec_5f7afa67b847d42715422015",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167098/019d0210-f4e7-72fa-8c6c-d055b22cfe73.webp",
      "image_media": {
        "alt_text": "Bedroom with a bed, nightstand, dresser, and chair.",
        "public_id": "019d0210-f4e7-72fa-8c6c-d055b22cfe73",
        "storage_key": "property/6767906449167098/019d0210-f4e7-72fa-8c6c-d055b22cfe73.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable queen-size bed, elegant nightstand, and a modern dresser. A cozy armchair by the window provides a relaxing spot.",
      "link": "false",
      "alt_text": "A bright bedroom here at Watercrest with soft carpet, neutral walls, and a large window, featuring a comfortable bed with light bedding, matching bedside tables with lamps, and a wooden dresser, creating a warm and relaxing atmosphere.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Watercrest_Favorites%20(22).jpg"
    },
    {
      "id": "ec_c12458b008de412cadc16c44",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167098/01a035aa-434d-7375-a72b-a24b00161f79.webp",
      "image_media": {
        "alt_text": "Empty living room with large window and sliding glass door to balcony",
        "public_id": "01a035aa-434d-7375-a72b-a24b00161f79",
        "storage_key": "property/6767906449167098/01a035aa-434d-7375-a72b-a24b00161f79.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious living room with plush carpet, large window offering a view of trees, and a sliding glass door leading to a private balcony.",
      "link": "false",
      "alt_text": "A bright, empty bedroom here at Watercrest with soft carpet, neutral walls, and large windows, featuring a sliding glass door leading to a private balcony and allowing abundant natural light.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Watercrest_Favorites%20(36).jpg"
    },
    {
      "id": "ec_f50c93453238e9eb58d8e8aa",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167098/01a035aa-4b18-769b-8028-ae188239e3d3.webp",
      "image_media": {
        "alt_text": "Spacious living room with large windows and sliding glass doors leading to a balcony.",
        "public_id": "01a035aa-4b18-769b-8028-ae188239e3d3",
        "storage_key": "property/6767906449167098/01a035aa-4b18-769b-8028-ae188239e3d3.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Bright and airy living room featuring a ceiling fan, plush carpeting, and expansive windows that offer views of the lush greenery outside. Sliding glass doors provide access to an outdoor space.",
      "link": "false",
      "alt_text": "A bright living room here at Watercrest with soft carpet, large windows, and a sliding glass door leading to a private balcony, allowing abundant natural light and creating a peaceful, open atmosphere.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Watercrest_Favorites%20(40).jpg"
    },
    {
      "id": "ec_140c55f3e0a06c1769fd6ce8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167098/01a035aa-56db-774f-af6f-e389e2e7787c.webp",
      "image_media": {
        "alt_text": "Empty bedroom with two closets and sliding glass door to balcony.",
        "public_id": "01a035aa-56db-774f-af6f-e389e2e7787c",
        "storage_key": "property/6767906449167098/01a035aa-56db-774f-af6f-e389e2e7787c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring two large closets and a sliding glass door providing access to a private balcony. Perfect for creating your own serene retreat.",
      "link": "false",
      "alt_text": "A spacious, empty bedroom here at Watercrest with soft carpet, neutral walls, and dual closets, featuring a sliding glass door leading to a private balcony, creating a bright and comfortable living space.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Watercrest_Favorites%20(34).jpg"
    },
    {
      "id": "ec_0c84314962676847f4b91904",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167098/01a035aa-3756-72bb-abfa-2143bca39388.webp",
      "image_media": {
        "alt_text": "Living room with a sofa, armchair, coffee table, and plants. Kitchen area visible.",
        "public_id": "01a035aa-3756-72bb-abfa-2143bca39388",
        "storage_key": "property/6767906449167098/01a035aa-3756-72bb-abfa-2143bca39388.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Bright and airy living room featuring comfortable seating and a connected kitchen space, perfect for modern living.",
      "link": "false",
      "alt_text": "A bright living room here at Watercrest with soft carpet, neutral walls, and a large window, featuring comfortable seating, a wooden coffee table, and an adjacent kitchen with white appliances, creating an open and inviting layout.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Watercrest_Favorites%20(41).jpg"
    },
    {
      "id": "ec_924ade3a35eca70c7049e66b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167098/01a035aa-7738-74db-b044-cb773a76a263.webp",
      "image_media": {
        "alt_text": "Spacious living room and kitchen area with neutral carpet and white appliances.",
        "public_id": "01a035aa-7738-74db-b044-cb773a76a263",
        "storage_key": "property/6767906449167098/01a035aa-7738-74db-b044-cb773a76a263.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Step into a welcoming living space featuring plush neutral carpeting. The adjacent kitchen area offers convenient white appliances, perfect for everyday living.",
      "link": "false",
      "alt_text": "A spacious living room here at Watercrest with soft carpet, neutral walls, and a large window, opening to a kitchen with white appliances and wood-style flooring, creating a bright and open living space.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Watercrest_Favorites%20(29).jpg"
    },
    {
      "id": "ec_4667e5d130a7a58c9616cce9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167098/01a035aa-593d-7790-b2ca-a8d03f959f72.webp",
      "image_media": {
        "alt_text": "Spacious living room with carpet and large windows overlooking greenery.",
        "public_id": "01a035aa-593d-7790-b2ca-a8d03f959f72",
        "storage_key": "property/6767906449167098/01a035aa-593d-7790-b2ca-a8d03f959f72.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "A generous living space with neutral carpet and ample natural light from large windows. This inviting room offers a comfortable and airy atmosphere, perfect for relaxation and entertaining.",
      "link": "false",
      "alt_text": "A spacious, empty living room here at Watercrest with soft carpet, large windows, and a sliding glass door leading to a private balcony, allowing abundant natural light and creating a bright, open atmosphere.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Watercrest_Favorites%20(42).jpg"
    },
    {
      "id": "ec_32a7bdb405a7091863e31310",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167098/01a035aa-8999-750b-9957-303ad0fc9cfe.webp",
      "image_media": {
        "alt_text": "Kitchen area with white appliances, cabinets, and countertops.",
        "public_id": "01a035aa-8999-750b-9957-303ad0fc9cfe",
        "storage_key": "property/6767906449167098/01a035aa-8999-750b-9957-303ad0fc9cfe.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A clean and functional kitchen featuring white appliances, ample cabinet space, and a view into the living area.",
      "link": "false",
      "alt_text": "A bright kitchen here at Watercrest with white cabinets, white appliances, and ample counter space, featuring a stainless steel sink and wood-style flooring, opening to a living area with a large window bringing in natural light.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Watercrest_Favorites%20(28).jpg"
    },
    {
      "id": "ec_8b12dc42fae2aa2c3a213498",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167098/01a035aa-86ee-740e-bfb3-149851c9ea3a.webp",
      "image_media": {
        "alt_text": "Bathroom with toilet, tub, shower, vanity, and sink.",
        "public_id": "01a035aa-86ee-740e-bfb3-149851c9ea3a",
        "storage_key": "property/6767906449167098/01a035aa-86ee-740e-bfb3-149851c9ea3a.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Apartment",
      "description": "A clean and functional bathroom featuring a bathtub with a tiled shower surround, a toilet, and a vanity with a sink and ample storage.",
      "link": "false",
      "alt_text": "A clean bathroom here at Watercrest with a bathtub-shower combo, white tile surround, and a single-sink vanity with ample counter space, featuring a large mirror and bright lighting for a fresh, functional feel.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Watercrest_Favorites%20(32).jpg"
    },
    {
      "id": "ec_93b1bad726aff64fc417340d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167098/01a035aa-94ed-77fd-9007-5368c94ec915.webp",
      "image_media": {
        "alt_text": "Stacked washer and dryer inside an apartment unit.",
        "public_id": "01a035aa-94ed-77fd-9007-5368c94ec915",
        "storage_key": "property/6767906449167098/01a035aa-94ed-77fd-9007-5368c94ec915.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Conveniently located stacked washer and dryer for all your laundry needs.",
      "link": "false",
      "alt_text": "A convenient in-home laundry area here at Watercrest with a stacked white washer and dryer in a hallway closet, offering a practical and space-saving feature for easy everyday living.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Watercrest_Favorites%20(26).jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_ce218b85-a2c2-41f4-a91b-74c7eb0a48ae",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "source": "custom",
      "poi_name": "Din Tai Fung 鼎泰豐",
      "poi_type": "Restaurants",
      "poi_address": "2621 NE 46th St, Seattle, WA 98105, USA",
      "poi_short_description": "Modern Seattle outpost of a Taiwan chain famed for its Shanghai-style soup dumplings and noodles.",
      "poi_long_description": "People say this Taiwanese restaurant serves delicious dumplings, noodles, and green beans. They highlight the consistently good food, the excellent jasmine tea, and the fun dessert dumplings. They also like the efficient service and the pleasant atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167098/019d0210-3fa2-7552-9457-13c0104635da.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0210-3fa2-7552-9457-13c0104635da",
        "storage_key": "property/6767906449167098/019d0210-3fa2-7552-9457-13c0104635da.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://dtf.com/en/locations/seattle-university-village",
      "poi_directions_map_url": "https://maps.google.com/?cid=814160589347388683&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "din-tai-fung-",
      "poi_latitude": "47.6614929",
      "poi_longitude": "-122.2996132",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 206-525-0958",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167098/019d0210-0c42-71bc-a358-ed103add530f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0210-0c42-71bc-a358-ed103add530f",
        "storage_key": "property/6767906449167098/019d0210-0c42-71bc-a358-ed103add530f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJKbLpOI8UkFQRC30sDr56TAs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "taiwanese_restaurant"
    },
    {
      "id": "custom_b0fed801-2565-411a-89c4-ae7794e4f19d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "source": "custom",
      "poi_name": "Dick's Drive-In",
      "poi_type": "Restaurants",
      "poi_address": "111 NE 45th St, Seattle, WA 98105, USA",
      "poi_short_description": "Part of an old-school chain of fast-food spots offering burgers, fries & hand-dipped shakes.",
      "poi_long_description": "People say this hamburger restaurant serves tasty burgers, fries, and milkshakes. They highlight the fast service and affordable prices. They also like the classic, old-school drive-in atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167098/019d0210-3f9b-7731-a944-7c033ce5591d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0210-3f9b-7731-a944-7c033ce5591d",
        "storage_key": "property/6767906449167098/019d0210-3f9b-7731-a944-7c033ce5591d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.ddir.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3317718277705693267&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "dicks-drive-in",
      "poi_latitude": "47.6610617",
      "poi_longitude": "-122.3277773",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "1 hour 3 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 206-632-5125",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167098/019d0210-0c42-71bc-a358-ed103add530f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0210-0c42-71bc-a358-ed103add530f",
        "storage_key": "property/6767906449167098/019d0210-0c42-71bc-a358-ed103add530f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJd5TY51gUkFQRU_h3DzLnCi4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "custom_9069ea96-d996-4e08-8ac5-116b28ef551d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "source": "custom",
      "poi_name": "Chick-fil-A",
      "poi_type": "Restaurants",
      "poi_address": "12801 Aurora Ave N, Seattle, WA 98133, USA",
      "poi_short_description": "Fast-food chain serving chicken sandwiches & nuggets along with salads & sides.",
      "poi_long_description": "Diners say this fast food restaurant serves up delicious chicken sandwiches, waffle fries, and nuggets, with a variety of tasty dipping sauces. They also highlight the friendly and efficient staff, and the clean and welcoming atmosphere.\n\nSome reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167098/019d0210-3f9b-7731-a944-81af0e069233.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0210-3f9b-7731-a944-81af0e069233",
        "storage_key": "property/6767906449167098/019d0210-3f9b-7731-a944-81af0e069233.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.chick-fil-a.com/locations/wa/aurora-ave-n-130th?utm_source=google&utm_medium=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=11462368208549691034&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chick-fil-a",
      "poi_latitude": "47.72255999999999",
      "poi_longitude": "-122.34533",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 206-364-0841",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167098/019d0210-0c42-71bc-a358-ed103add530f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0210-0c42-71bc-a358-ed103add530f",
        "storage_key": "property/6767906449167098/019d0210-0c42-71bc-a358-ed103add530f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4Z6AfAQTkFQRmr5VyyeDEp8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_8cd8c833-2b27-45e5-923b-a0757b6b13d6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "source": "custom",
      "poi_name": "DERU",
      "poi_type": "Restaurants",
      "poi_address": "723 9th Ave, Kirkland, WA 98033, USA",
      "poi_short_description": "Sleek market/eatery with pizza, sandwiches, salads & sweets made from locally sourced ingredients.",
      "poi_long_description": "People say this restaurant serves fresh, flavorful food, including pizzas, sandwiches, and salads, and offers a variety of drinks and desserts. They highlight the generous portions, fair prices, and cozy, fun atmosphere. They also like the friendly and attentive staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167098/019d0210-3f7d-72bc-9504-5fd817ed49e8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0210-3f7d-72bc-9504-5fd817ed49e8",
        "storage_key": "property/6767906449167098/019d0210-3f7d-72bc-9504-5fd817ed49e8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.derumarket.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7755306842299324447&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "deru",
      "poi_latitude": "47.68201999999999",
      "poi_longitude": "-122.19416",
      "poi_miles_from_property": "10.3",
      "poi_walking_minutes": "3 hours 49 mins",
      "poi_biking_minutes": "59 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 425-298-0268",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167098/019d0210-0c42-71bc-a358-ed103add530f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0210-0c42-71bc-a358-ed103add530f",
        "storage_key": "property/6767906449167098/019d0210-0c42-71bc-a358-ed103add530f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9SkOAusSkFQRH1ho03tioGs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_543ccd04-966f-462d-8666-b624156a70ee",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "source": "custom",
      "poi_name": "University Village",
      "poi_type": "Shopping & Retail",
      "poi_address": "2623 NE University Village St, Seattle, WA 98105, USA",
      "poi_short_description": "Al fresco shopping center since the 1950s, with local stores, well-known brands & dining options.",
      "poi_long_description": "People say this shopping center offers a wide variety of shops, restaurants, and cafes, and is a convenient place for students. They highlight the beautiful outdoor setting, the fun and vibrant atmosphere, and the ample free parking. They also like the kid-friendly amenities, such as a playground and water sculptures.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167098/019d0210-4504-756b-bda9-cc00a402e7c8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0210-4504-756b-bda9-cc00a402e7c8",
        "storage_key": "property/6767906449167098/019d0210-4504-756b-bda9-cc00a402e7c8.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://uvillage.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4185780485491805676&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "university-village",
      "poi_latitude": "47.6616885",
      "poi_longitude": "-122.2990339",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 206-523-0622",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167098/019d0210-0c49-729b-9fb4-983ad030f4a0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0210-0c49-729b-9fb4-983ad030f4a0",
        "storage_key": "property/6767906449167098/019d0210-0c49-729b-9fb4-983ad030f4a0.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ2_IcB4YUkFQR7E2AoSzhFjo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_224120f4-e33d-4a8f-8491-526051f405ad",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "source": "custom",
      "poi_name": "Northgate Station",
      "poi_type": "Shopping & Retail",
      "poi_address": "401 NE Northgate Way, Seattle, WA 98125, USA",
      "poi_short_description": "Indoor shopping mall with department stores, a play area & a couple dozen eateries.",
      "poi_long_description": "People say this shopping center offers a variety of stores, including a Barnes & Noble, Target, and Best Buy, as well as a skating center and a Kraken store. They also highlight the convenient access to the light rail, with easy tap in and tap out, and the clean, well-lit, and easy-to-navigate station.\n\nOther reviews mention the mall can be under construction.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167098/019d0210-4458-77fc-a270-da20d107d550.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0210-4458-77fc-a270-da20d107d550",
        "storage_key": "property/6767906449167098/019d0210-4458-77fc-a270-da20d107d550.webp",
        "width": 1000,
        "height": 669
      },
      "poi_business_url": "https://www.simon.com/mall/northgate-station",
      "poi_directions_map_url": "https://maps.google.com/?cid=7968531460125271769&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "northgate-station",
      "poi_latitude": "47.70612269999999",
      "poi_longitude": "-122.3258649",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 206-362-4777",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167098/019d0210-0c49-729b-9fb4-983ad030f4a0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0210-0c49-729b-9fb4-983ad030f4a0",
        "storage_key": "property/6767906449167098/019d0210-0c49-729b-9fb4-983ad030f4a0.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJn7o7cFYRkFQR2aZK1iTplW4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_d78e0068-0491-4077-bf51-1923677eac78",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "source": "custom",
      "poi_name": "Whole Foods Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "1026 NE 64th St, Seattle, WA 98115, USA",
      "poi_short_description": "Eco-minded chain with natural & organic grocery items, housewares & other products (most sell wine).",
      "poi_long_description": "People say this grocery store offers a wide selection of fresh produce, organic foods, and unique items, as well as a hot bar, deli, and bakery. They also highlight the friendly and helpful staff, and the clean and well-stocked grab-and-go area.\n\nOther reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167098/019d0210-447d-769b-9eed-1ba5b77fa230.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0210-447d-769b-9eed-1ba5b77fa230",
        "storage_key": "property/6767906449167098/019d0210-447d-769b-9eed-1ba5b77fa230.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.wholefoodsmarket.com/stores/rooseveltsquare?utm_source=google&utm_medium=organic&utm_campaign=listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=12345175728734872312&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "whole-foods-market",
      "poi_latitude": "47.6751401",
      "poi_longitude": "-122.3159059",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 206-985-1500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167098/019d0210-0c58-7265-8c6b-63c4b726f25b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0210-0c58-7265-8c6b-63c4b726f25b",
        "storage_key": "property/6767906449167098/019d0210-0c58-7265-8c6b-63c4b726f25b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJA3kY6m8UkFQR-CIE8erfUqs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_b6e4800f-e085-497a-965c-4f96093bbbd8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "source": "custom",
      "poi_name": "Trader Joe's",
      "poi_type": "Shopping & Retail",
      "poi_address": "4555 Roosevelt Way NE, Seattle, WA 98105, USA",
      "poi_short_description": "Grocery chain with a variety of signature items, plus produce, dairy & more (most sell wine & beer).",
      "poi_long_description": "Shoppers say this grocery store offers a wide variety of healthful options at reasonable prices, including frozen meals, snacks, and cheese. They also highlight the friendly and helpful staff, and the clean and well-stocked store.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167098/019d0210-49b8-76eb-be17-55633042f86c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0210-49b8-76eb-be17-55633042f86c",
        "storage_key": "property/6767906449167098/019d0210-49b8-76eb-be17-55633042f86c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.traderjoes.com/wa/seattle/137/?utm_source=gmb&utm_medium=organic&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=10181451224793493704&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "trader-joes",
      "poi_latitude": "47.66268549999999",
      "poi_longitude": "-122.3177437",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 4 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 206-547-6299",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167098/019d0210-0c58-7265-8c6b-63c4b726f25b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0210-0c58-7265-8c6b-63c4b726f25b",
        "storage_key": "property/6767906449167098/019d0210-0c58-7265-8c6b-63c4b726f25b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJq6Rq_l8UkFQRyDDI__HHS40",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_834af233-9862-4b93-abae-b845109a60e9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "source": "custom",
      "poi_name": "University of Washington",
      "poi_type": "Education",
      "poi_address": "1410 NE Campus Pkwy, Seattle, WA 98195, USA",
      "poi_short_description": "This 1861 research school in Downtown Seattle is known for medicine, engineering & business.",
      "poi_long_description": "This 1861 research school in Downtown Seattle is known for medicine, engineering & business.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167098/019d0210-0099-7383-8af0-041d5edf53a7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0210-0099-7383-8af0-041d5edf53a7",
        "storage_key": "property/6767906449167098/019d0210-0099-7383-8af0-041d5edf53a7.webp",
        "width": 1024,
        "height": 576
      },
      "poi_business_url": "http://www.washington.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7742862557588237219&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "university-of-washington",
      "poi_latitude": "47.65671709999999",
      "poi_longitude": "-122.3066181",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 206-543-2100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167098/019d0210-0fd5-74ff-be02-68bfaceb12dd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0210-0fd5-74ff-be02-68bfaceb12dd",
        "storage_key": "property/6767906449167098/019d0210-0fd5-74ff-be02-68bfaceb12dd.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ6zWFnZIUkFQRoyu4AXksdGs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_790717bf-bacb-4951-a1e7-98a4791122a1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "source": "custom",
      "poi_name": "University of Washington Bothell",
      "poi_type": "Education",
      "poi_address": "17927 113th Ave NE, Bothell, WA 98011, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167098/019d0210-0125-7247-b6fe-8ee19601cec6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0210-0125-7247-b6fe-8ee19601cec6",
        "storage_key": "property/6767906449167098/019d0210-0125-7247-b6fe-8ee19601cec6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.uwb.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14107547568998928606&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "university-of-washington-bothell",
      "poi_latitude": "47.7584761",
      "poi_longitude": "-122.190891",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 21 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 425-352-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167098/019d0210-0fd5-74ff-be02-68bfaceb12dd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0210-0fd5-74ff-be02-68bfaceb12dd",
        "storage_key": "property/6767906449167098/019d0210-0fd5-74ff-be02-68bfaceb12dd.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ46EtkWAOkFQR3lAb3sQTyMM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_b5c8d202-4589-4207-b76d-9cc57c1c0f6a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "source": "custom",
      "poi_name": "Shoreline Community College",
      "poi_type": "Education",
      "poi_address": "16101 Greenwood Ave N, Shoreline, WA 98133, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167098/019d020f-cf96-751c-9885-5fe115d0b850.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d020f-cf96-751c-9885-5fe115d0b850",
        "storage_key": "property/6767906449167098/019d020f-cf96-751c-9885-5fe115d0b850.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.shoreline.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5663351517267791817&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "shoreline-community-college",
      "poi_latitude": "47.747453",
      "poi_longitude": "-122.3586266",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 206-546-4101",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167098/019d0210-0fd5-74ff-be02-68bfaceb12dd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0210-0fd5-74ff-be02-68bfaceb12dd",
        "storage_key": "property/6767906449167098/019d0210-0fd5-74ff-be02-68bfaceb12dd.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJPYEIfNsQkFQRyY_qADNEmE4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_21eeda52-6069-4bf3-bd8f-76abc91df0a7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "source": "custom",
      "poi_name": "North Seattle College",
      "poi_type": "Education",
      "poi_address": "9600 College Way N, Seattle, WA 98103, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167098/019d0210-4b55-747f-a66c-5c3bbe9b3fea.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0210-4b55-747f-a66c-5c3bbe9b3fea",
        "storage_key": "property/6767906449167098/019d0210-4b55-747f-a66c-5c3bbe9b3fea.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://northseattle.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=404283079753513623&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "north-seattle-college",
      "poi_latitude": "47.6989479",
      "poi_longitude": "-122.3326717",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 206-934-3600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167098/019d0210-0fd5-74ff-be02-68bfaceb12dd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0210-0fd5-74ff-be02-68bfaceb12dd",
        "storage_key": "property/6767906449167098/019d0210-0fd5-74ff-be02-68bfaceb12dd.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJVVWVdQEUkFQRl7porVFNnAU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_67c425af-5cd5-4948-b893-e4b153b43af6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "source": "custom",
      "poi_name": "Edmonds College",
      "poi_type": "Education",
      "poi_address": "20000 68th Ave W, Lynnwood, WA 98036, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167098/019d0210-4f00-74d9-b9ef-1072d2627c54.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0210-4f00-74d9-b9ef-1072d2627c54",
        "storage_key": "property/6767906449167098/019d0210-4f00-74d9-b9ef-1072d2627c54.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "https://www.edmonds.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18049943253476694463&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "edmonds-college",
      "poi_latitude": "47.8163839",
      "poi_longitude": "-122.3266396",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 44 mins",
      "poi_biking_minutes": "59 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 425-640-1459",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167098/019d0210-0fd5-74ff-be02-68bfaceb12dd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0210-0fd5-74ff-be02-68bfaceb12dd",
        "storage_key": "property/6767906449167098/019d0210-0fd5-74ff-be02-68bfaceb12dd.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ3S0IQMsakFQRv9lvn8FHfvo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_03369f85-3a73-487f-9f0a-fbde420860c0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "source": "custom",
      "poi_name": "Woodland Park Zoo",
      "poi_type": "Entertainment",
      "poi_address": "Seattle, WA 98103, USA",
      "poi_short_description": "92-acre zoo with nearly 300 species, a vintage carousel, summer concerts & an indoor play space.",
      "poi_long_description": "People say this zoo offers a wide variety of animals, including gorillas, hippos, lions, and snow leopards, and features a historic carousel and a dinosaur exhibit. They highlight the spacious enclosures, lush vegetation, and family-friendly atmosphere, and recommend purchasing an annual pass for discounted entry and access to special events. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167098/019d0210-4f79-74bf-a52d-9b600cafce48.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0210-4f79-74bf-a52d-9b600cafce48",
        "storage_key": "property/6767906449167098/019d0210-4f79-74bf-a52d-9b600cafce48.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.zoo.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8962776519554476210&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "woodland-park-zoo",
      "poi_latitude": "47.668436",
      "poi_longitude": "-122.3508786",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 34 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 206-548-2500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167098/019d0210-0fa3-72db-bd67-fc9d1f233216.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0210-0fa3-72db-bd67-fc9d1f233216",
        "storage_key": "property/6767906449167098/019d0210-0fa3-72db-bd67-fc9d1f233216.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJydSuSkkUkFQRsqhB-cEtYnw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "zoo"
    },
    {
      "id": "custom_d9a397fd-402a-490b-9ab2-7dcd4b370671",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "source": "custom",
      "poi_name": "Husky Stadium",
      "poi_type": "Entertainment",
      "poi_address": "3800 Montlake Blvd NE, Seattle, WA 98105, USA",
      "poi_short_description": "Clean football stadium with picturesque mountain and lake views, plus concessions.",
      "poi_long_description": "People say this stadium offers great views of the field and surrounding scenery, and has a fun and electric atmosphere. They highlight the easy access via light rail, the numerous food options, and the efficient beer purchasing system. They also like the beautiful campus and the exciting game-day experience.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167098/019d0210-4fe7-700a-bc27-0e387f3f14e4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0210-4fe7-700a-bc27-0e387f3f14e4",
        "storage_key": "property/6767906449167098/019d0210-4fe7-700a-bc27-0e387f3f14e4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.gohuskies.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1750582404826581946&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "husky-stadium",
      "poi_latitude": "47.6503177",
      "poi_longitude": "-122.3016101",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 23 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 206-543-2210",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167098/019d0210-65e2-701b-8a24-464a122afcdc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0210-65e2-701b-8a24-464a122afcdc",
        "storage_key": "property/6767906449167098/019d0210-65e2-701b-8a24-464a122afcdc.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJR4k7qZQUkFQRusu8FWxRSxg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_a4b5c20c-58f4-4d9a-b283-2a5fc2e47a45",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "source": "custom",
      "poi_name": "Burke Museum of Natural History and Culture",
      "poi_type": "Entertainment",
      "poi_address": "4303 Memorial Way Northeast, Seattle, WA 98195, USA",
      "poi_short_description": "University of Washington museum explores Northwest history from dinosaurs to Native American life.",
      "poi_long_description": "People say this museum offers a diverse collection of fossils, indigenous artifacts, and interactive exhibits, with a focus on paleontology, archaeology, and biology. They highlight the educational and engaging experience, especially for children, and the opportunity to see scientists working in real-time. They also like the well-organized layout and the friendly, helpful staff.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.burkemuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14849234123748631754&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "burke-museum-of-natural-history-and-culture",
      "poi_latitude": "47.6606147",
      "poi_longitude": "-122.3115987",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 5 mins",
      "poi_biking_minutes": "57 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 206-543-7907",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167098/019d0210-12f3-740f-88e6-20539731ba22.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0210-12f3-740f-88e6-20539731ba22",
        "storage_key": "property/6767906449167098/019d0210-12f3-740f-88e6-20539731ba22.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJpWFsC4sUkFQRymSlzMITE84",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_87c44eeb-9330-4847-a1eb-a4ec2da6cb74",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "source": "custom",
      "poi_name": "Alaska Airlines Arena",
      "poi_type": "Entertainment",
      "poi_address": "3870 Montlake Blvd NE, Seattle, WA 98105, USA",
      "poi_short_description": "10,000-seat University of Washington sporting venue hosting basketball, gymnastics & volleyball.",
      "poi_long_description": "People say this arena offers a great experience for sporting events, with good views from most seats and a collegiate atmosphere. They highlight the easy parking and convenient access to public transportation. They also like the friendly staff and clean facilities.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.gohuskies.com/ViewArticle.dbml?ATCLID=208565960",
      "poi_directions_map_url": "https://maps.google.com/?cid=12628585578645820243&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "alaska-airlines-arena",
      "poi_latitude": "47.65206540000001",
      "poi_longitude": "-122.3021452",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 17 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167098/019d0210-0fa3-72db-bd67-fc9d1f233216.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0210-0fa3-72db-bd67-fc9d1f233216",
        "storage_key": "property/6767906449167098/019d0210-0fa3-72db-bd67-fc9d1f233216.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJodS6NpMUkFQRUxPOtqy_Qa8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_4cc99ba9-9d2e-4fab-affe-e1614aaf4018",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "source": "custom",
      "poi_name": "Henry Art Gallery",
      "poi_type": "Entertainment",
      "poi_address": "15th Ave NE & University of Washington, NE 41st St, Seattle, WA 98195, USA",
      "poi_short_description": "Modest-sized gallery at the University of Washington focusing on contemporary art exhibits.",
      "poi_long_description": "People say this art museum offers interesting and beautiful pieces of art, including multimedia and thought-provoking exhibits. They also highlight the free entry, clean building, and kind staff.\n\nOther reviews mention the art can be unconventional.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167098/019d0210-5252-716a-94f8-23ea15617d17.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0210-5252-716a-94f8-23ea15617d17",
        "storage_key": "property/6767906449167098/019d0210-5252-716a-94f8-23ea15617d17.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.henryart.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8125824423033647840&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "henry-art-gallery",
      "poi_latitude": "47.6562767",
      "poi_longitude": "-122.3117218",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 11 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 206-543-2280",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167098/019d0210-12f3-740f-88e6-20539731ba22.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0210-12f3-740f-88e6-20539731ba22",
        "storage_key": "property/6767906449167098/019d0210-12f3-740f-88e6-20539731ba22.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJixg3IPMUkFQR4DIdokK6xHA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "custom_2735e75d-a38f-4c05-a3cd-b12577456a92",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "source": "custom",
      "poi_name": "LA Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "13244 Aurora Ave N, Seattle, WA 98133, USA",
      "poi_short_description": "Modern gym with clean amenities, including a 3-lane pool and a basketball court.",
      "poi_long_description": "Some gym goers say this gym has a wide variety of equipment, including a dry sauna, hot tub, and a 3-lane lap pool, and the staff is friendly.\n\nOther reviews mention the gym can be crowded and some people don't follow sauna etiquette.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167098/019d0210-5556-7068-a15b-d095347c2af1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0210-5556-7068-a15b-d095347c2af1",
        "storage_key": "property/6767906449167098/019d0210-5556-7068-a15b-d095347c2af1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.lafitness.com/Pages/clubhome.aspx?clubid=326&utm_source=google&utm_medium=googlemaps&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=2707988696116944436&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "la-fitness",
      "poi_latitude": "47.726277",
      "poi_longitude": "-122.3431823",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 206-973-0232",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167098/019d0210-0fa3-72db-bd67-fc9d1f233216.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0210-0fa3-72db-bd67-fc9d1f233216",
        "storage_key": "property/6767906449167098/019d0210-0fa3-72db-bd67-fc9d1f233216.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJs2Xd2TARkFQRNN7SH1-1lCU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_1fd3df98-886e-484d-b3de-13e2cf234a18",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "source": "custom",
      "poi_name": "24 Hour Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "507 NE Northgate Way, Seattle, WA 98125, USA",
      "poi_short_description": "Chain fitness center featuring a pool, cardio machines and personal trainers as well as basketball courts.",
      "poi_long_description": "People say this gym offers a wide variety of equipment, including a pool, sauna, and steam room, and has friendly staff.\n\nOther reviews mention the gym can be crowded and some machines can be broken.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167098/019d0210-5651-7012-a865-9ecae55629f8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0210-5651-7012-a865-9ecae55629f8",
        "storage_key": "property/6767906449167098/019d0210-5651-7012-a865-9ecae55629f8.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.24hourfitness.com/gyms/seattle-wa/northgate-fifth-ave-super-sport?Adb_id=GGL_LOC_ACQ_CDP",
      "poi_directions_map_url": "https://maps.google.com/?cid=5024363022030936683&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "24-hour-fitness",
      "poi_latitude": "47.7082989",
      "poi_longitude": "-122.3229892",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 206-368-2431",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167098/019d0210-0fa3-72db-bd67-fc9d1f233216.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0210-0fa3-72db-bd67-fc9d1f233216",
        "storage_key": "property/6767906449167098/019d0210-0fa3-72db-bd67-fc9d1f233216.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJh1rcAlcRkFQRaxrDXowfukU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_52c63c14-94c4-4f03-a88f-dc446ddf585f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "13201 Aurora Ave N, Seattle, WA 98133, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167098/019d020f-de58-7324-bdbf-4df63f3ac62f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d020f-de58-7324-bdbf-4df63f3ac62f",
        "storage_key": "property/6767906449167098/019d020f-de58-7324-bdbf-4df63f3ac62f.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/seattle-aurora-ave-wa?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=11165522815278832073&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "47.72605",
      "poi_longitude": "-122.34696",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 206-659-4577",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167098/019d0210-0fa3-72db-bd67-fc9d1f233216.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0210-0fa3-72db-bd67-fc9d1f233216",
        "storage_key": "property/6767906449167098/019d0210-0fa3-72db-bd67-fc9d1f233216.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2elQYTERkFQRydk20Nfn85o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_6190055b-0680-4b9f-9595-873356e9c0bb",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "source": "custom",
      "poi_name": "Seattle Children's Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "4800 Sand Point Way NE, Seattle, WA 98105, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.seattlechildrens.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11535247879101277020&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "seattle-childrens-hospital",
      "poi_latitude": "47.6628364",
      "poi_longitude": "-122.281996",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 4 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 206-987-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167098/019d0210-135f-71f9-8549-961984e27650.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0210-135f-71f9-8549-961984e27650",
        "storage_key": "property/6767906449167098/019d0210-135f-71f9-8549-961984e27650.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJrYx10YIUkFQRXOPoZdRuFaA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_86eb0268-72a8-4371-ab85-3996ee091c82",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "source": "custom",
      "poi_name": "UW Medical Center - Montlake | Seattle Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "1959 NE Pacific St Main Hospital, Seattle, WA 98195, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.uwmedicine.org/locations/uw-medical-center-montlake?utm_source=extnet&utm_medium=organic&utm_campaign=website_clicks&y_source=1_MTAwNDcxNDM0MS03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=10469901287147718853&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "uw-medical-center---montlake--seattle-hospital",
      "poi_latitude": "47.6498254",
      "poi_longitude": "-122.3080279",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 22 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 206-598-3300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167098/019d0210-135f-71f9-8549-961984e27650.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0210-135f-71f9-8549-961984e27650",
        "storage_key": "property/6767906449167098/019d0210-135f-71f9-8549-961984e27650.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJEU9wSOwUkFQRxUjYrb-PTJE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_15235d17-ebdb-4153-bdd9-4bbc82d3d222",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "source": "custom",
      "poi_name": "Golden Gardens Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "8498 Seaview Pl NW, Seattle, WA 98117, USA",
      "poi_short_description": "City park draws outdoor lovers for Puget Sound & mountain views, trails & a dog off-leash area.",
      "poi_long_description": "People say this city park offers a beautiful sandy beach, stunning sunsets, and views of the Puget Sound and Olympic Mountains. They highlight the park's spaciousness, with areas for volleyball, picnics, and bonfires, as well as walking trails and a playground. They also like the relaxed and family-friendly vibe, and the opportunity to spot wildlife like seals and eagles.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.seattle.gov/parks/find/parks/golden-gardens-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=6569770599323732682&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "golden-gardens-park",
      "poi_latitude": "47.6917517",
      "poi_longitude": "-122.4030912",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 54 mins",
      "poi_biking_minutes": "1 hour 26 mins",
      "poi_driving_minutes": "27 mins",
      "poi_business_phone": "+1 206-684-4075",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167098/019d0210-100c-756d-8c07-abcd98ad4503.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0210-100c-756d-8c07-abcd98ad4503",
        "storage_key": "property/6767906449167098/019d0210-100c-756d-8c07-abcd98ad4503.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ72JgjmQWkFQRygp_TI2DLFs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_fa25a14d-d427-459f-9abf-363de4e1bc03",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "source": "custom",
      "poi_name": "Warren G. Magnuson Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "7400 Sand Point Way NE, Seattle, WA 98115, USA",
      "poi_short_description": "Leafy city park along the shores of Lake Washington, with historic art deco homes, wetlands & art.",
      "poi_long_description": "People say this city park offers a large off-leash dog area, a beach, and trails for walking and hiking. They highlight the beautiful views, the spaciousness, and the variety of activities, including sports fields, a playground, and a community garden. They also like the convenient parking and the family-friendly atmosphere.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.seattle.gov/parks/find/parks/magnuson-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=13794854175829797151&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "warren-g-magnuson-park",
      "poi_latitude": "47.6797687",
      "poi_longitude": "-122.2536022",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 206-684-4075",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167098/019d0210-100c-756d-8c07-abcd98ad4503.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0210-100c-756d-8c07-abcd98ad4503",
        "storage_key": "property/6767906449167098/019d0210-100c-756d-8c07-abcd98ad4503.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJTSbT3aATkFQRHymm3sgqcb8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_9d2ce750-3903-4a1b-bfd0-146336fa09ae",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "source": "custom",
      "poi_name": "Green Lake Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "7201 East Green Lake Dr N, Seattle, WA 98115, USA",
      "poi_short_description": "Recreation area with trails, beach & boathouse, plus tennis courts, baseball fields & indoor pool.",
      "poi_long_description": "People say this park offers a paved trail for walking, running, and biking, as well as opportunities for kayaking, paddle boating, and swimming. They highlight the beautiful views, relaxing atmosphere, and the abundance of activities, including basketball, pickleball, and fishing. They also like the clean water and the presence of ducks, geese, and other wildlife. ",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.seattle.gov/parks/find/parks/green-lake-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=12201424080476219256&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "green-lake-park",
      "poi_latitude": "47.6802143",
      "poi_longitude": "-122.3284021",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 206-684-4075",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167098/019d0210-100c-756d-8c07-abcd98ad4503.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0210-100c-756d-8c07-abcd98ad4503",
        "storage_key": "property/6767906449167098/019d0210-100c-756d-8c07-abcd98ad4503.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJEbIG9xUUkFQReKeuJo4qVKk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_70d5b695-a9e3-4bd9-a13d-89242c0c6b70",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "source": "custom",
      "poi_name": "Juanita Beach Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "9703 NE Juanita Dr, Kirkland, WA 98034, USA",
      "poi_short_description": "This park features a sandy beach, volleyball & tennis courts, ball fields, fishing & a playground.",
      "poi_long_description": "People say this park offers a sandy beach, a playground, picnic areas, and a pier with beautiful views. They highlight the relaxing and rejuvenating vibe, and the family-friendly atmosphere. They also like the clean restrooms and well-maintained facilities.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167098/019d0210-5b44-779a-a081-b4ff64d9ef08.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0210-5b44-779a-a081-b4ff64d9ef08",
        "storage_key": "property/6767906449167098/019d0210-5b44-779a-a081-b4ff64d9ef08.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.kirklandwa.gov/depart/parks/Parks_and_Open_Spaces/Online_Parks_Guide/Parks_Pop-up_Main/Parks_and_Community_Services__Juanita_Beach_Park.htm",
      "poi_directions_map_url": "https://maps.google.com/?cid=15784180254516446732&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "juanita-beach-park",
      "poi_latitude": "47.7046205",
      "poi_longitude": "-122.2147696",
      "poi_miles_from_property": "8.1",
      "poi_walking_minutes": "2 hours 57 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 425-587-3300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167098/019d0210-100c-756d-8c07-abcd98ad4503.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0210-100c-756d-8c07-abcd98ad4503",
        "storage_key": "property/6767906449167098/019d0210-100c-756d-8c07-abcd98ad4503.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJiSZt12cSkFQRDAYwNVCsDNs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_ae571044-ee9a-43c2-b1e2-77f364cfc888",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "source": "custom",
      "poi_name": "Carkeek Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "950 NW Carkeek Park Rd, Seattle, WA 98177, USA",
      "poi_short_description": "220 acres of forests, meadows, wetlands, creeks & beaches, with Puget Sound & mountain views.",
      "poi_long_description": "People say this city park offers beautiful trails, a beach, a playground, and picnic areas. They highlight the peaceful and scenic atmosphere, and the opportunity to watch trains go by. They also like the ample parking and the variety of activities, including hiking, birdwatching, and wildlife viewing.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167098/019d0210-5b44-779a-a081-b10ed74e083e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0210-5b44-779a-a081-b10ed74e083e",
        "storage_key": "property/6767906449167098/019d0210-5b44-779a-a081-b10ed74e083e.webp",
        "width": 600,
        "height": 600
      },
      "poi_business_url": "http://www.seattle.gov/parks/find/parks/carkeek-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=1222184061577422517&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "carkeek-park",
      "poi_latitude": "47.7115955",
      "poi_longitude": "-122.3682005",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "2 hours 3 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 206-386-4236",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167098/019d0210-100c-756d-8c07-abcd98ad4503.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0210-100c-756d-8c07-abcd98ad4503",
        "storage_key": "property/6767906449167098/019d0210-100c-756d-8c07-abcd98ad4503.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJyVw29LsWkFQRtWZ3uO0R9hA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_ca4f098f-14df-4912-b6e2-d76d59bbc01a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "source": "custom",
      "poi_name": "U District",
      "poi_type": "Transportation & Transit",
      "poi_address": "Seattle, WA 98105, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this light rail station is clean and spacious. They highlight the station is well-lit and has security. They also like the changing art installations.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167098/019d0210-5b60-71ff-bdb9-7b0e400d6d66.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0210-5b60-71ff-bdb9-7b0e400d6d66",
        "storage_key": "property/6767906449167098/019d0210-5b60-71ff-bdb9-7b0e400d6d66.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.soundtransit.org/ride-with-us/stops-stations/u-district-station",
      "poi_directions_map_url": "https://maps.google.com/?cid=8874690119994055692&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "u-district",
      "poi_latitude": "47.6599885",
      "poi_longitude": "-122.3140745",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 7 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167098/019d0210-0fa3-72db-bd67-fc9d1f233216.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0210-0fa3-72db-bd67-fc9d1f233216",
        "storage_key": "property/6767906449167098/019d0210-0fa3-72db-bd67-fc9d1f233216.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ93n1LIsUkFQRDBzq3aQ7KXs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_6455c8c0-e95b-4780-8cab-9558b6057170",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "source": "custom",
      "poi_name": "Lynnwood City Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "Lynnwood, WA 98036, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167098/019d0210-5edb-7129-83cc-ed678dde9e65.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0210-5edb-7129-83cc-ed678dde9e65",
        "storage_key": "property/6767906449167098/019d0210-5edb-7129-83cc-ed678dde9e65.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=806806651792536392&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lynnwood-city-center",
      "poi_latitude": "47.81563999999999",
      "poi_longitude": "-122.29478",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 25 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167098/019d0210-0fa3-72db-bd67-fc9d1f233216.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0210-0fa3-72db-bd67-fc9d1f233216",
        "storage_key": "property/6767906449167098/019d0210-0fa3-72db-bd67-fc9d1f233216.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJD2JiZkQFkFQRSDOECmBaMgs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_4c0bf578-bb0a-4dfc-a118-a3b88590ae29",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "source": "custom",
      "poi_name": "University of Washington Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "Seattle, WA 98105, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167098/019d0210-5f75-7213-a947-f92e4e1cfe8b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0210-5f75-7213-a947-f92e4e1cfe8b",
        "storage_key": "property/6767906449167098/019d0210-5f75-7213-a947-f92e4e1cfe8b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.soundtransit.org/ride-with-us/stops-stations/university-washington-station",
      "poi_directions_map_url": "https://maps.google.com/?cid=18042961121833481987&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "university-of-washington-station",
      "poi_latitude": "47.65031",
      "poi_longitude": "-122.30374",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 18 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167098/019d0210-0fa3-72db-bd67-fc9d1f233216.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0210-0fa3-72db-bd67-fc9d1f233216",
        "storage_key": "property/6767906449167098/019d0210-0fa3-72db-bd67-fc9d1f233216.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJIdBrZusUkFQRA3cRa4t5Zfo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_f4297196-06ca-41f8-acb7-b1b487f5cf20",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "source": "custom",
      "poi_name": "Roosevelt",
      "poi_type": "Transportation & Transit",
      "poi_address": "Seattle, WA 98115, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.soundtransit.org/ride-with-us/stops-stations/roosevelt-station",
      "poi_directions_map_url": "https://maps.google.com/?cid=5282645169596799289&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "roosevelt",
      "poi_latitude": "47.67611000000001",
      "poi_longitude": "-122.31604",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167098/019d0210-0fa3-72db-bd67-fc9d1f233216.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0210-0fa3-72db-bd67-fc9d1f233216",
        "storage_key": "property/6767906449167098/019d0210-0fa3-72db-bd67-fc9d1f233216.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1X3KKnAUkFQRORlACMu5T0k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_c034a173-062d-4885-9da3-e1f3fd28fbab",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "source": "custom",
      "poi_name": "Northgate",
      "poi_type": "Transportation & Transit",
      "poi_address": "Seattle, WA 98125, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.soundtransit.org/ride-with-us/stops-stations/northgate-station",
      "poi_directions_map_url": "https://maps.google.com/?cid=16388369830807636916&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "northgate",
      "poi_latitude": "47.7030228",
      "poi_longitude": "-122.3283221",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167098/019d0210-0fa3-72db-bd67-fc9d1f233216.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0210-0fa3-72db-bd67-fc9d1f233216",
        "storage_key": "property/6767906449167098/019d0210-0fa3-72db-bd67-fc9d1f233216.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ80dxYFURkFQRtIsEJYgvb-M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_54a8dbdc-f696-4c5b-acf6-04a1cdd008b3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "source": "custom",
      "poi_name": "Google Kirkland - Kirkland Urban",
      "poi_type": "Major Employers & Offices",
      "poi_address": "425 Urban Plz Suite#223, Kirkland, WA 98033, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167098/019d0210-6063-7601-92c7-8d2b63842c60.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0210-6063-7601-92c7-8d2b63842c60",
        "storage_key": "property/6767906449167098/019d0210-6063-7601-92c7-8d2b63842c60.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://about.google/company-info/locations/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12392096200761415899&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "google-kirkland---kirkland-urban",
      "poi_latitude": "47.6775887",
      "poi_longitude": "-122.1992122",
      "poi_miles_from_property": "10.4",
      "poi_walking_minutes": "3 hours 51 mins",
      "poi_biking_minutes": "1 hour 0 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167098/019d0210-0fa3-72db-bd67-fc9d1f233216.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0210-0fa3-72db-bd67-fc9d1f233216",
        "storage_key": "property/6767906449167098/019d0210-0fa3-72db-bd67-fc9d1f233216.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJF0JJdpgTkFQR2xjapNaR-as",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_8ce07f2f-8f9f-4b83-98f0-6f51876b0c18",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "source": "custom",
      "poi_name": "Philips Healthcare",
      "poi_type": "Major Employers & Offices",
      "poi_address": "22100 Bothell Everett Hwy, Bothell, WA 98021, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167098/019d0210-6086-70f8-b5ce-c54996c1743c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0210-6086-70f8-b5ce-c54996c1743c",
        "storage_key": "property/6767906449167098/019d0210-6086-70f8-b5ce-c54996c1743c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.healthcare.philips.com/main?link_origin=global_en_HC%3Amain%3Aheader-healthcare",
      "poi_directions_map_url": "https://maps.google.com/?cid=3444942013548930731&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "philips-healthcare",
      "poi_latitude": "47.7986093",
      "poi_longitude": "-122.215873",
      "poi_miles_from_property": "8.8",
      "poi_walking_minutes": "3 hours 17 mins",
      "poi_biking_minutes": "58 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 888-744-5477",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167098/019d0210-0fa3-72db-bd67-fc9d1f233216.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0210-0fa3-72db-bd67-fc9d1f233216",
        "storage_key": "property/6767906449167098/019d0210-0fa3-72db-bd67-fc9d1f233216.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJI_1KSwkPkFQRqyZnXYLkzi8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_59d9e31b-ec76-404e-99cc-882218f37b1b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "source": "custom",
      "poi_name": "AT&T Bothell 8",
      "poi_type": "Major Employers & Offices",
      "poi_address": "20205 N Creek Pkwy, Bothell, WA 98011, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://att.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1181624086596595890&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "att-bothell-8",
      "poi_latitude": "47.7757162",
      "poi_longitude": "-122.1880432",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 42 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167098/019d0210-0fa3-72db-bd67-fc9d1f233216.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0210-0fa3-72db-bd67-fc9d1f233216",
        "storage_key": "property/6767906449167098/019d0210-0fa3-72db-bd67-fc9d1f233216.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6W1Wk_YOkFQRsrCio9j4ZRA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_b11f6f60-f04b-4097-bc6d-346756803531",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "source": "custom",
      "poi_name": "Zumiez Home Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "4001 204th St SW, Lynnwood, WA 98036, USA",
      "poi_short_description": "Chain retailer offering trendy, brand-name clothing & shoes, plus gear for skate- & snowboarders.",
      "poi_long_description": "Chain retailer offering trendy, brand-name clothing & shoes, plus gear for skate- & snowboarders.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.zumiez.com/?utm_source=google+my+business&utm_medium=organic&utm_content=home+office&utm_campaign=store+locations",
      "poi_directions_map_url": "https://maps.google.com/?cid=2871018272505013437&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "zumiez-home-office",
      "poi_latitude": "47.8146549",
      "poi_longitude": "-122.2869949",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 22 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 877-828-6929",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167098/019d0210-0fa3-72db-bd67-fc9d1f233216.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0210-0fa3-72db-bd67-fc9d1f233216",
        "storage_key": "property/6767906449167098/019d0210-0fa3-72db-bd67-fc9d1f233216.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJS51hCktCkYARvSRRVOjn1yc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_6269097e-d0a8-4886-ae07-22b9c98ae934",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "source": "custom",
      "poi_name": "Kirkland City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "123 5th Ave, Kirkland, WA 98033, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.kirklandwa.gov/depart.htm",
      "poi_directions_map_url": "https://maps.google.com/?cid=9219559950987716846&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "kirkland-city-hall",
      "poi_latitude": "47.6781959",
      "poi_longitude": "-122.2071862",
      "poi_miles_from_property": "10.1",
      "poi_walking_minutes": "3 hours 43 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 425-587-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167098/019d0210-139b-7213-9a6d-f528e8200ae5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0210-139b-7213-9a6d-f528e8200ae5",
        "storage_key": "property/6767906449167098/019d0210-139b-7213-9a6d-f528e8200ae5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJtTt_SOYSkFQR7mgKmO108n8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    }
  ],
  "office_hours": [
    {
      "id": "custom_ef56cd50-305b-4b8b-b7b0-c9cc11d071be",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_fb239662-d0cc-46d3-907d-f806a874657c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_9cb5ae03-6d3f-4815-bba1-2298204bccb9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_335cffd1-b3f9-4ba4-a1fa-6f6eb72509fa",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_d91ecd3a-a6fa-45b5-8f68-aeb5b9eaaa64",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_874396bc-8cb8-4303-a2ab-d0679ab712ed",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "rating": "5.0",
      "name": "MaryAnn McClung",
      "text": "I moved here from a sister property as a single mom, sight unseen, from out of state and couldn’t have been luckier! The staff is like family, the neighbors are incredible, and I absolutely love my apartment. Although I was saving for a home after starting over, I’m seriously reconsidering my timeline since I’m no longer in a rush. They are dog-friendly, child friendly, within walking distance to the high school, across the street from two amazing restaurant (and one fast food), and a short drive to nearly anything. There’s even a great neighborhood with a view of the lake that everyone walks in.",
      "date": "2024-10-11",
      "title": ""
    },
    {
      "id": "custom_f02d0a8b-7e9d-4d15-8ddb-8e78151270d8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "rating": "5.0",
      "name": "Sophia Hofman",
      "text": "Living here is a dream, the property managers - Kiersten, Sierra and Travis are wonderful, such genuine people and are always there to assist for whatever you need. The maintenance team is also super helpful and quick, you submit a request and they get on it sometimes even same day. Beautiful area right by the Burke Gilman and Lake Washington, highly recommend it here. Very relaxing and everyone is really friendly. Also the apartments are spacious and every unit has a deck. Check it out, you won’t want to leave! Thanks, Watercrest team!",
      "date": "2025-08-11",
      "title": ""
    },
    {
      "id": "custom_9ce0941d-2f87-4e5f-920f-6c5787e446e8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "rating": "5.0",
      "name": "Austin Johnson",
      "text": "Lived here since July 2024 and just submitted to renew. I was in a massive transition time when I moved here and have always been skeptical about renting but I'm very happy I stumbled across Watercrest. Move in process was easy, simple, straightforward. Everything spelled out clearly (and I did read the entire lease). The office staff is courteous, professional, and very friendly. Always fun to visit the office and chat with other residents (though I really visit for the pets). Weidner values positive relationships with owner/tenant and Keirsten and Sierra are a great duo. The same vibe extends to the other residents here too - most people are generally nice and often smile at each other while crossing paths. Maintenance requests are done in a reasonable amount of time. Fortunate to live on the top floor with a fantastic east facing lake view from my balcony. Easy access to Bothell Way, LFP, and 145th to get to Seattle since I commute in. For living on the edge of Lake City, I've never had security concerns about my building or my vehicle.\n\nI feel like it's easier to go online and post about what you don't like about something rather than what you like about something. Well, I like this place. Used the apartment gym for a while before getting a membership at a larger gym. The pool is a life saver on hot days (ya know, third floor, heat rises). Most importantly my cat seems pretty happy here.\n\nThanks Watercrest staff for making home feel like a place I like coming home to.",
      "date": "2025-06-01",
      "title": ""
    },
    {
      "id": "custom_5f68f156-3fd9-42e8-abcc-c60520fb0970",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "rating": "5.0",
      "name": "Michi T",
      "text": "We moved in April of 23, this is by far the largest apartment community that I've lived in. It's been really good for us. For the most part it's a quiet community, plenty of dog lovers! It's great that bags & recepticals are provided all around the property. Most people are pretty mellow.\nThe management staff has been very approachable and supportive. They helped us navigate a couple of issues recently with positive resolution. It's a reassurance that they are here.\nIn Community,\nMichelle T",
      "date": "2023-07-14",
      "title": ""
    },
    {
      "id": "custom_538e201a-3a40-483d-aea8-0eabac79b9a9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "rating": "5.0",
      "name": "Lynn R",
      "text": "The maintenance team are exceptional. Any work orders submitted are immediately handled with politeness and a smile . The outdoor pool and area are pristine and well maintained. I’m having the best summer ever meeting and hanging out with my neighbors enjoying the sun. Some think the pool temperature is too cold but perfect for me. Also the manager Kirsten is fun, nice and helpful. And her new helper Travis is a sweet, fellow Pisces and a wonderful addition.",
      "date": "2023-07-26",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_09898c61-f868-4e92-b705-4432ec76b251",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167098/019d0211-4c77-770f-b94a-7321dcea927c.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Living room with large windows and balcony access",
        "public_id": "019d0211-4c77-770f-b94a-7321dcea927c",
        "storage_key": "property/6767906449167098/019d0211-4c77-770f-b94a-7321dcea927c.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Watercrest | Aqua Floor Plan | 1 Br 1 Ba",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=P8FV1FcKSqC"
    },
    {
      "id": "custom_80885093-fb44-47c3-ac30-7a1befe18c82",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": null,
      "virtual_tour_thumbnail_media": null,
      "virtual_tour_title": "1BR, 1BA - 779 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?model=1q4NfpVNh8e"
    },
    {
      "id": "custom_19762757-831e-412b-8fa2-20c30d22ec46",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": null,
      "virtual_tour_thumbnail_media": null,
      "virtual_tour_title": "2BR, 2BA - 1,060 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?model=52or8GRcCsG"
    },
    {
      "id": "custom_fd09fab6-0bab-4f1a-a012-7ef6b1121427",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": null,
      "virtual_tour_thumbnail_media": null,
      "virtual_tour_title": "2BR, 2BA - 1,077 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?model=CJLqwVVtT4W"
    }
  ],
  "faqs": [],
  "fees": [
    {
      "id": "ec_86639221efefec2cda331788",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "source": "yardi",
      "external_id": "584b483b7787a5b3",
      "name": "NSF Tenant Fee",
      "description": "Returned Payment Charge",
      "amount": 50,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Per Lease",
      "category": "Lease",
      "charge_code": "nsff",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_188dbf47a09a55350adf7d8d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "source": "yardi",
      "external_id": "2b5af8dc045230c1",
      "name": "Late Fee",
      "description": "Late Fee - Base",
      "amount": 75,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Per Lease",
      "category": "Lease",
      "charge_code": "late",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_00dcf7da7919c139ee999f0d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "source": "yardi",
      "external_id": "72d4d8073a79d806",
      "name": "2nd Late Fee",
      "description": "2nd Late Fee - Daily",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "$5 per day up to 20 days",
      "amount_type": "text",
      "timing": "Per Lease",
      "category": "Lease",
      "charge_code": "late",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_c485d63ddd8c9b4523edb465",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "source": "yardi",
      "external_id": "775d5b715d7880ac",
      "name": "Early Termination Fee",
      "description": "Early Termination Fee",
      "amount": 200,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "percentage",
      "timing": "Per Lease",
      "category": "Term",
      "charge_code": "term",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_93278223604f761b9262beaa",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "source": "yardi",
      "external_id": "157eec62ff95cb44",
      "name": "Transfer Fee",
      "description": "Fee to transfer apartments",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Amount varies",
      "amount_type": "text",
      "timing": "Per Lease",
      "category": "Transfer",
      "charge_code": "tran",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_48f84b4a65b365a885ec3bde",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "source": "yardi",
      "external_id": "7df4d013117cb177",
      "name": "Water Charge",
      "description": "Water Utility Charge",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Based on square footage and occupancy",
      "amount_type": "text",
      "timing": "Recurring",
      "category": "Utility",
      "charge_code": "ubwater",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_6f94c5b918032478899cff1c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "source": "yardi",
      "external_id": "52754ec531f0db4e",
      "name": "Sewer Charge",
      "description": "Sewer Utility Charge",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Based on square footage and occupancy",
      "amount_type": "text",
      "timing": "Recurring",
      "category": "Utility",
      "charge_code": "ubsewer",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_bd045d119464e6c79a182e49",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "source": "yardi",
      "external_id": "3739d8257125b796",
      "name": "Garbage Charge",
      "description": "Garbage Utility Charge",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Equally divided, paid monthly.",
      "amount_type": "text",
      "timing": "Recurring",
      "category": "Utility",
      "charge_code": "ubtrash",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_b12a953bc1b0796779f27be3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "source": "yardi",
      "external_id": "fd132f56d49bc82b",
      "name": "Pest Control",
      "description": "Pest Control Charge",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Equally divided, paid monthly.",
      "amount_type": "text",
      "timing": "Recurring",
      "category": "Utility",
      "charge_code": "pest",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_792eb75cb220a1853b75704b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "source": "yardi",
      "external_id": "f964c4b9c08d2236",
      "name": "Gas Charge",
      "description": "Gas Utility Charge",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Equally divided, paid monthly.",
      "amount_type": "text",
      "timing": "Recurring",
      "category": "Utility",
      "charge_code": "gasc",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_d3b4510e151071fa8d442ac3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "source": "yardi",
      "external_id": "7aba17d1c375f702",
      "name": "Common Area Electric",
      "description": "Common Area Electric Charge",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Equally divided, paid monthly.",
      "amount_type": "text",
      "timing": "Recurring",
      "category": "Utility",
      "charge_code": "elec",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_493c5d3286ac9c458822e4da",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "source": "yardi",
      "external_id": "cac461adce307f20",
      "name": "Utility Billing Admin Fee",
      "description": "Utility Admin Fee",
      "amount": 3.95,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Recurring",
      "category": "Utility",
      "charge_code": "ubadmin",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    }
  ],
  "pet_policies": [
    {
      "id": "ec_59208ed6b73fce41dceece76",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "source": "yardi",
      "external_id": "2465576",
      "pet_type": "cats",
      "allowed": true,
      "max_count": 2,
      "weight_limit": 0,
      "deposit": 300,
      "fee": 300,
      "monthly_rent": 50,
      "description": "Up to 2 pets per home are welcome.",
      "restrictions": "false"
    },
    {
      "id": "ec_6e95a8f73ff7bf8e2b47404d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "source": "yardi",
      "external_id": "2465575",
      "pet_type": "dogs",
      "allowed": true,
      "max_count": 2,
      "weight_limit": 100,
      "deposit": 300,
      "fee": 300,
      "monthly_rent": 50,
      "description": "Up to 2 pets per home are welcome.",
      "restrictions": "Breed restrictions apply"
    }
  ],
  "lead_collectors": [
    {
      "lead_collector_id": "019db0c6-6592-71bf-a608-32024403b314",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Watercrest Website",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098"
    },
    {
      "lead_collector_id": "019db0c6-724b-71ef-ac48-6763e0c497dd",
      "lead_source": "LANDING_PAGE",
      "name": "Watercrest Landing Page",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "source": "generator",
      "page_item_url": "waterfront-apartments-lake-forest-park",
      "search_query": "waterfront apartments Lake Forest Park",
      "category": "Amenity",
      "h1_title": "Waterfront Apartments in Lake Forest Park",
      "h2_subtitle": "Discover serene waterfront living in Lake Forest Park. Enjoy the comfort and style at Watercrest, located conveniently near the water.",
      "page_copy": "Experience life at Watercrest, where waterfront apartments in Lake Forest Park provide an idyllic setting. Nestled near the scenic shores, our community offers residents a perfect blend of tranquility and urban convenience. Each apartment includes a private patio or balcony, allowing you to unwind while appreciating the soothing views of the lake.\n\nLiving at Watercrest means enjoying premium amenities such as an on-site sauna for ultimate relaxation, efficient on-site maintenance, and hassle-free living. Residents can also benefit from modern conveniences like a dishwasher and elevator access. Embrace the best of waterfront living in Lake Forest Park at Watercrest, where comfort meets convenience in a picturesque environment.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Waterfront Apartments in Lake Forest Park - Watercrest",
      "seo_description": "Experience waterfront living at Watercrest in Lake Forest Park. Enjoy serene views with premium amenities like sauna and patios.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "source": "generator",
      "page_item_url": "apartments-with-pool-king-county",
      "search_query": "apartments with pool in King County",
      "category": "Amenity",
      "h1_title": "Apartments with Pool in King County",
      "h2_subtitle": "Explore premium apartments with a pool in King County. Watercrest offers luxury living with top-notch amenities.",
      "page_copy": "Looking for apartments with a pool in King County? While Watercrest in Lake Forest Park offers a range of fantastic amenities, including a sauna, private patios or balconies, and convenient elevator access, it is primarily renowned for its serene waterfront setting. Although a pool isn't available on-site, residents enjoy the comfort of our spacious apartments and the convenience of nearby local attractions.\n\nLocated in King County, Watercrest provides a peaceful retreat with modern conveniences. From on-site maintenance ensuring hassle-free living to well-equipped kitchens featuring dishwashers, Watercrest aims to enhance your lifestyle. Experience tranquil living in a picturesque environment in our Lake Forest Park community.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Pool in King County - Watercrest",
      "seo_description": "Explore luxury living at Watercrest in King County. Enjoy a sauna, modern amenities, and serene surroundings without a pool.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "source": "generator",
      "page_item_url": "lake-forest-park-apartments-fitness-center",
      "search_query": "Lake Forest Park apartments with fitness center",
      "category": "Amenity",
      "h1_title": "Apartments with Fitness Center in Lake Forest Park",
      "h2_subtitle": "Discover Lake Forest Park apartments with fitness facilities. Enjoy a vibrant community experience at Watercrest.",
      "page_copy": "While Watercrest in Lake Forest Park does not feature a fitness center, it offers an array of fantastic amenities catering to a comfortable lifestyle. Residents can revel in the tranquil setting enhanced by features like a sauna, which offers a peaceful retreat for relaxation. Each apartment is equipped with a patio or balcony, perfect for some fresh air and relaxation with a view.\n\nConvenience is key at Watercrest, with amenities including an efficient on-site maintenance team, modern kitchens with dishwashers, and easy accessibility via elevators. Located in the heart of Lake Forest Park, Watercrest provides easy access to local gyms and outdoor recreation, ensuring residents have everything they need just moments away from home.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Lake Forest Park Apartments - Watercrest",
      "seo_description": "Watercrest in Lake Forest Park offers tranquil living with amenities like a sauna and easy access to local fitness facilities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "source": "generator",
      "page_item_url": "lake-forest-park-wa-apartments-with-dishwasher",
      "search_query": "Lake Forest Park WA apartments with dishwasher",
      "category": "Amenity",
      "h1_title": "Lake Forest Park Apartments with Dishwasher",
      "h2_subtitle": "Find Lake Forest Park, WA apartments equipped with modern dishwashers. Enjoy convenience and comfort at Watercrest.",
      "page_copy": "At Watercrest, enjoy the perks of Lake Forest Park, WA apartments featuring modern conveniences like dishwashers. Each unit is thoughtfully designed to offer ease of living, ensuring household chores are a breeze. With the dishwasher included, you can spend more time enjoying the array of amenities and the beautiful waterfront views accessible from your very own patio or balcony.\n\nBesides a dishwasher, Watercrest offers a range of features designed for comfortable living including a soothing sauna, elevators for ease of access, and reliable on-site maintenance. Situated in the heart of Lake Forest Park, our community not only offers modern convenience but also a serene atmosphere close to local attractions and services.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Lake Forest Park WA Apartments with Dishwasher",
      "seo_description": "Explore Lake Forest Park WA apartments at Watercrest with dishwashers. Enjoy modern living with convenient amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "source": "generator",
      "page_item_url": "apartments-with-sauna-near-98155",
      "search_query": "apartments with sauna near 98155",
      "category": "Amenity",
      "h1_title": "Apartments with Sauna Near 98155",
      "h2_subtitle": "Discover apartments with a sauna close to 98155. Watercrest offers tranquil living with top amenities in Lake Forest Park.",
      "page_copy": "For those searching for apartments with a sauna near the 98155 area, Watercrest in Lake Forest Park is an ideal choice. Our cozy community boasts a relaxing sauna, perfect for unwinding after a long day. Enhance your living experience with additional amenities such as private patios or balconies where you can enjoy the scenic surroundings.\n\nAt Watercrest, convenience and comfort go hand in hand. Enjoy the benefits of on-site maintenance, modern kitchens equipped with dishwashers, and convenient elevators providing easy access throughout the building. Situated in a prime location within King County, residents are close to local attractions and services, making Watercrest the perfect place for a balanced lifestyle.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Sauna Near 98155 - Watercrest",
      "seo_description": "Watercrest offers apartments with a sauna near 98155. Experience relaxing amenities and convenient living in Lake Forest Park.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "source": "generator",
      "page_item_url": "studio-apartments-in-lake-forest-park",
      "search_query": "studio apartments in Lake Forest Park",
      "category": "Floorplan",
      "h1_title": "Studio Apartments in Lake Forest Park",
      "h2_subtitle": "Find cozy studio apartments in Lake Forest Park. Watercrest offers efficiency with comfort in a beautiful setting.",
      "page_copy": "Explore the charm of living in studio apartments in Lake Forest Park at Watercrest. Our studio units are designed to maximize comfort and functionality without sacrificing style. Residents enjoy access to modern amenities such as dishwashers, ensuring a hassle-free living experience.\n\nWatercrest's location provides a peaceful retreat yet keeps you connected to everything Lake Forest Park has to offer. Enjoy the convenience of elevators, a rejuvenating sauna, and a balcony or patio for some personal outdoor space. Situated in the vibrant community of King County, Watercrest enhances apartment living by combining modern comforts with nature's beauty.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Studio Apartments in Lake Forest Park - Watercrest",
      "seo_description": "Discover comfortable studio apartments at Watercrest in Lake Forest Park. Enjoy modern amenities and a serene environment.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "source": "generator",
      "page_item_url": "1-bedroom-apartments-near-king-county",
      "search_query": "1 bedroom apartments near King County",
      "category": "Floorplan",
      "h1_title": "1 Bedroom Apartments Near King County",
      "h2_subtitle": "Explore spacious 1 bedroom apartments near King County. Watercrest offers modern living with top-notch amenities in Lake Forest Park.",
      "page_copy": "Watercrest presents spacious 1 bedroom apartments near King County, perfect for those seeking a blend of comfort and convenience. Our residences feature thoughtful layouts paired with essential amenities, including state-of-the-art kitchens equipped with dishwashers.\n\nLiving at Watercrest provides community members with access to luxurious amenities such as a relaxing sauna and private patios or balconies. With on-site maintenance and elevators, Watercrest ensures stress-free living. Located in the serene city of Lake Forest Park, these 1 bedroom apartments offer easy access to the local attractions and services of King County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "1 Bedroom Apartments Near King County - Watercrest",
      "seo_description": "Find spacious 1 bedroom apartments near King County at Watercrest. Enjoy modern amenities and serene living in Lake Forest Park.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "source": "generator",
      "page_item_url": "2-bedroom-apartments-in-wa-98155",
      "search_query": "2 bedroom apartments in WA 98155",
      "category": "Floorplan",
      "h1_title": "2 Bedroom Apartments in WA 98155",
      "h2_subtitle": "Discover spacious 2 bedroom apartments in WA 98155. Watercrest offers comfortable living in Lake Forest Park.",
      "page_copy": "For those in search of spacious 2 bedroom apartments in WA 98155, look no further than Watercrest. Our two-bedroom units are designed to provide ample living space and modern comforts. Residents can enjoy the convenience of a fully-equipped kitchen with a dishwasher and stylish interiors.\n\nWatercrest's amenities offer added value and relaxation, including a rejuvenating sauna, private balconies, and the ease of an on-site elevator. Nestled in the picturesque Lake Forest Park, our location offers a perfect balance of tranquility and accessibility to King County's vibrant community. Come find your new home with us, where comfort meets convenience.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "2 Bedroom Apartments in WA 98155 - Watercrest",
      "seo_description": "Explore 2 bedroom apartments in WA 98155 at Watercrest. Enjoy spacious living and modern amenities in Lake Forest Park.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "source": "generator",
      "page_item_url": "3-bedroom-apartments-bothell-way-ne",
      "search_query": "3 bedroom apartments Bothell Way NE",
      "category": "Floorplan",
      "h1_title": "3 Bedroom Apartments on Bothell Way NE",
      "h2_subtitle": "Find stunning 3 bedroom apartments on Bothell Way NE. Watercrest offers family-friendly living with top-notch amenities.",
      "page_copy": "Discover the expansive 3 bedroom apartments on Bothell Way NE at Watercrest, a home designed for families or those needing extra space. Our three-bedroom homes offer an ideal blend of generous living areas and modern conveniences, including fully-equipped kitchens.\n\nAt Watercrest, residents enjoy premium amenities like a relaxing sauna, and each unit includes its own balcony or patio, perfect for peaceful outdoor moments. The property's on-site maintenance and elevators add to the convenience and ease of living. Located in the scenic setting of Lake Forest Park, Watercrest provides a harmonious blend of natural beauty and urban ease in King County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "3 Bedroom Apartments on Bothell Way NE - Watercrest",
      "seo_description": "Explore spacious 3 bedroom apartments on Bothell Way NE at Watercrest. Enjoy family-friendly living with modern amenities in Lake Forest Park.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "source": "generator",
      "page_item_url": "apartments-near-university-of-washington-seattle",
      "search_query": "apartments near university of washington seattle",
      "category": "School",
      "h1_title": "Apartments Near University of Washington Seattle",
      "h2_subtitle": "Explore ideal apartments near University of Washington Seattle. Watercrest offers convenient living in Lake Forest Park.",
      "page_copy": "Watercrest provides the perfect accommodation for students and professionals looking for apartments near University of Washington Seattle. These thoughtfully designed units cater to a dynamic lifestyle, offering modern amenities like fully-equipped kitchens with dishwashers.\n\nResidents benefit from the tranquility of Lake Forest Park while staying connected to the bustling atmosphere of the university area. Our community includes luxurious perks such as a sauna, private balconies, and on-site maintenance services. With convenient access via Bothell Way NE, Watercrest ensures easy commuting options and a peaceful retreat, making it an excellent choice for those seeking proximity to UW Seattle.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near University of Washington Seattle",
      "seo_description": "Find apartments near University of Washington Seattle at Watercrest in Lake Forest Park. Enjoy modern amenities and convenient living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "source": "generator",
      "page_item_url": "apartments-close-to-university-of-washington-bothell",
      "search_query": "apartments close to university of washington bothell",
      "category": "School",
      "h1_title": "Apartments Close to University of Washington Bothell",
      "h2_subtitle": "Discover apartments close to University of Washington Bothell. Watercrest offers a perfect home base in Lake Forest Park.",
      "page_copy": "Watercrest presents an ideal living option for those seeking apartments close to University of Washington Bothell. Our units offer a seamless blend of modern design and practical living, with elegant features that include fully-equipped kitchens and in-unit dishwashers.\n\nJust a short drive from UW Bothell, our residents enjoy an array of convenient amenities such as an on-site sauna, elevator access, and private patios/balconies, ensuring a comfortable stay. Located in the serene Lake Forest Park, Watercrest provides both an escape from the hustle and bustle and easy accessibility to educational facilities, making it perfectly suited for students and faculty alike.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to University of Washington Bothell",
      "seo_description": "Explore apartments close to University of Washington Bothell at Watercrest in Lake Forest Park. Modern living and convenience await.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "source": "generator",
      "page_item_url": "lake-forest-park-apartments-near-shoreline-community-college",
      "search_query": "lake forest park apartments near shoreline community college",
      "category": "School",
      "h1_title": "Lake Forest Park Apartments Near Shoreline CC",
      "h2_subtitle": "Experience the convenience of Lake Forest Park apartments near Shoreline Community College at Watercrest, offering a perfect balance of comfort and accessibility.",
      "page_copy": "Watercrest invites you to experience comfortable living in Lake Forest Park, with apartments perfectly situated near Shoreline Community College. These residences provide a harmonious blend of style and function, featuring essential conveniences like in-unit dishwashers and private patios or balconies for relaxing outdoor time.\n\nOur community is designed with a focus on easy living, offering excellent amenities such as a rejuvenating sauna and responsive on-site maintenance. Enjoy the natural beauty surrounding Lake Forest Park while being just minutes away from Shoreline Community College, making Watercrest an ideal choice for students and professionals seeking a convenient commute and a soothing retreat.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Lake Forest Park Apartments Near Shoreline CC",
      "seo_description": "Find ideal Lake Forest Park apartments near Shoreline Community College at Watercrest with convenient access and comfortable living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "source": "generator",
      "page_item_url": "apartments-near-north-seattle-college-wa",
      "search_query": "apartments near north seattle college wa",
      "category": "School",
      "h1_title": "Apartments Near North Seattle College, WA",
      "h2_subtitle": "Discover ideal apartments near North Seattle College, WA. Watercrest offers contemporary living in Lake Forest Park.",
      "page_copy": "Watercrest provides the perfect solution for those searching for apartments near North Seattle College, WA. Our community boasts well-appointed units complete with modern conveniences like a dishwasher and outdoor patios or balconies designed for relaxation.\n\nConveniently positioned in Lake Forest Park, Watercrest ensures easy access to North Seattle College while offering a retreat from urban life. Enjoy on-site amenities such as a sauna and elevator services, complemented by responsive maintenance support. Our residents appreciate the balance of proximity to college life and the serene environment at Watercrest, making it an ideal home for students and faculty alike.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near North Seattle College, WA",
      "seo_description": "Find spacious apartments near North Seattle College, WA at Watercrest in Lake Forest Park. Experience modern comfort and convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "source": "generator",
      "page_item_url": "lake-forest-park-apartments-close-to-edmonds-college",
      "search_query": "lake forest park apartments close to edmonds college",
      "category": "School",
      "h1_title": "Lake Forest Park Apartments Close to Edmonds College",
      "h2_subtitle": "Explore Lake Forest Park apartments close to Edmonds College, where convenience meets comfort at Watercrest.",
      "page_copy": "Watercrest offers an exceptional living experience with Lake Forest Park apartments close to Edmonds College. Our modern residences are designed to suit the needs of students and professionals alike, featuring amenities such as dishwashers and spacious patios or balconies.\n\nLocated just a short commute from Edmonds College, Watercrest makes balancing education and relaxation seamless. Residents enjoy serene living paired with facilities like a soothing sauna and efficient on-site maintenance. With easy access to academic institutions and the natural beauty of Lake Forest Park, Watercrest is the perfect place to call home for those connected to Edmonds College.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Lake Forest Park Apartments Close to Edmonds College",
      "seo_description": "Find convenient Lake Forest Park apartments close to Edmonds College at Watercrest, offering modern amenities and a relaxed environment.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "source": "generator",
      "page_item_url": "apartments-near-seattle-childrens-hospital-wa",
      "search_query": "apartments near seattle children's hospital wa",
      "category": "Hospital",
      "h1_title": "Apartments Near Seattle Children's Hospital, WA",
      "h2_subtitle": "Discover comfortable living with apartments near Seattle Children's Hospital, WA at Watercrest, offering convenience and serenity.",
      "page_copy": "Located in the picturesque Lake Forest Park, Watercrest offers ideal apartments near Seattle Children's Hospital, WA. Our community combines modern amenities with a tranquil environment, making it an excellent choice for healthcare professionals and hospital visitors.\n\nEach apartment is designed with comfort in mind, featuring dishwashers and private patios or balconies. The on-site sauna and reliable maintenance ensure a worry-free lifestyle. With an easy commute to Seattle Children's Hospital, Watercrest serves as a serene retreat after busy workdays, providing the perfect balance between accessibility to medical facilities and peaceful living.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Seattle Children's Hospital, WA",
      "seo_description": "Comfort and convenience meet at Watercrest. Find apartments near Seattle Children's Hospital, WA, with modern amenities in Lake Forest Park.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "source": "generator",
      "page_item_url": "lake-forest-park-apartments-close-to-uw-medical-center-montlake",
      "search_query": "lake forest park apartments close to uw medical center montlake",
      "category": "Hospital",
      "h1_title": "Lake Forest Park Apartments Near UW Medical Center",
      "h2_subtitle": "Explore Lake Forest Park apartments close to UW Medical Center Montlake at Watercrest, combining convenience with comfort.",
      "page_copy": "Watercrest provides an ideal living solution with Lake Forest Park apartments close to UW Medical Center Montlake. Designed with modern tenants in mind, each unit features a dishwasher and balcony or patio, making it perfect for relaxing after a long day.\n\nPositioned in the tranquil setting of Lake Forest Park, Watercrest ensures a straightforward commute to the UW Medical Center Montlake. Residents appreciate the comprehensive amenities, including an on-site sauna and responsive maintenance services, creating a pleasant living environment. Whether you're working at the medical center or visiting, Watercrest offers a peaceful home base with easy city access.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Lake Forest Park Apts Near UW Medical Center Montlake",
      "seo_description": "Find comfort at Watercrest with Lake Forest Park apartments close to UW Medical Center Montlake, featuring modern amenities and serene living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "source": "generator",
      "page_item_url": "apartments-near-green-lake-park-seattle",
      "search_query": "apartments near green lake park seattle",
      "category": "Park",
      "h1_title": "Apartments Near Green Lake Park, Seattle",
      "h2_subtitle": "Discover the perfect balance at Watercrest, featuring apartments near Green Lake Park, Seattle, combining urban convenience with natural beauty.",
      "page_copy": "Watercrest offers an amazing living experience with apartments near Green Lake Park, Seattle. Located in the serene Lake Forest Park, our community provides a convenient escape from the city hustle while remaining accessible to Seattle’s vibrant surroundings.\n\nEach apartment is equipped with modern amenities such as a dishwasher and a private patio or balcony. For those seeking a peaceful retreat after exploring Green Lake Park, our on-site sauna and expert maintenance services ensure a comfortable lifestyle. Watercrest is the ideal residence for those seeking proximity to natural beauty and urban advantages combined.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Green Lake Park, Seattle",
      "seo_description": "Discover Watercrest's appeal with apartments near Green Lake Park, Seattle, featuring modern amenities and a serene environment.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "source": "generator",
      "page_item_url": "apartments-close-to-juanita-beach-park-king-county",
      "search_query": "apartments close to juanita beach park king county",
      "category": "Park",
      "h1_title": "Apartments Near Juanita Beach Park, King County",
      "h2_subtitle": "Find premium apartments close to Juanita Beach Park in King County at Watercrest, blending comfort with accessibility.",
      "page_copy": "Nestled in Lake Forest Park, Watercrest offers exceptional apartments close to Juanita Beach Park in King County. Our location provides an ideal combination of natural beauty and modern comforts, creating a lifestyle unique in its convenience and serenity.\n\nFeaturing amenities such as private patios/balconies and dishwashers, each unit is crafted with residents' ease in mind. Access to on-site maintenance and a relaxing sauna ensures a hassle-free, enjoyable living experience. Watercrest positions you just a short drive away from Juanita Beach Park while delivering a cozy retreat with all the city perks close at hand.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Close to Juanita Beach Park, King County",
      "seo_description": "Explore Watercrest for apartments close to Juanita Beach Park, King County, featuring modern amenities and a tranquil living environment.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "source": "generator",
      "page_item_url": "apartments-near-u-district-lake-forest-park",
      "search_query": "apartments near u district lake forest park",
      "category": "Transit",
      "h1_title": "Apartments Near U District, Lake Forest Park",
      "h2_subtitle": "Experience comfortable living at Watercrest, with apartments near U District, Lake Forest Park, offering modern convenience and serene surroundings.",
      "page_copy": "Watercrest is the perfect choice for those seeking apartments near U District, Lake Forest Park. Located in a tranquil environment, our community provides easy access to the bustling University District while offering a peaceful retreat from the city's fast pace.\n\nResidents enjoy thoughtfully-designed units featuring modern conveniences like dishwashers and private patios or balconies. With on-site maintenance and amenities such as a sauna, Watercrest ensures a welcoming and stress-free living experience. This ideal location offers the best of both worlds, allowing easy escapes into nature alongside the vibrancy of the nearby U District.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near U District, Lake Forest Park",
      "seo_description": "Choose Watercrest for apartments near U District, Lake Forest Park, featuring modern amenities and a tranquil, yet connected location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "source": "generator",
      "page_item_url": "lynnwood-city-center-accessible-apartments",
      "search_query": "lynnwood city center accessible apartments",
      "category": "Transit",
      "h1_title": "Accessible Apartments near Lynnwood City Center",
      "h2_subtitle": "Watercrest offers accessible apartments near Lynnwood City Center, emphasizing comfort and convenience with great amenities.",
      "page_copy": "Located in Lake Forest Park, Watercrest provides accessible apartments just a short distance from Lynnwood City Center. Our community focuses on delivering both comfort and accessibility by including features such as elevators for easy mobility and ensuring our amenities cater to diverse needs.\n\nEach apartment is designed with modern touches like dishwashers and private patios or balconies, allowing you to relax in style. On-site maintenance is always ready to assist, and a serene sauna offers a place to unwind. Discover the convenience of city living coupled with the tranquility of suburban comfort at Watercrest.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Accessible Apts Near Lynnwood City Center",
      "seo_description": "Find accessible apartments near Lynnwood City Center at Watercrest, combining modern amenities and suburban tranquility.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "source": "generator",
      "page_item_url": "university-washington-station-nearby-rental-homes",
      "search_query": "university of washington station nearby rental homes",
      "category": "Transit",
      "h1_title": "Rental Homes Near University of Washington Station",
      "h2_subtitle": "Discover Watercrest's rental homes, conveniently located near the University of Washington Station, and offering premium amenities for modern living.",
      "page_copy": "Experience the best of urban connectivity and serene living at Watercrest. Our rental homes are ideally situated near the University of Washington Station, providing a perfect retreat with easy access to public transportation.\n\nWith amenities like private patios or balconies, dishwashers, and a relaxing sauna, Watercrest ensures a comfortable and convenient living experience. On-site maintenance and elevators complement the ease of daily life, while our serene Lake Forest Park setting offers a peaceful contrast to the urban sprawl, making daily commutes seamless and stress-free.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Homes Near University of Washington Station",
      "seo_description": "Watercrest offers rental homes near University of Washington Station with modern amenities, ideal for convenient and comfortable living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "source": "generator",
      "page_item_url": "roosevelt-area-apartments-king-county",
      "search_query": "roosevelt area apartments in king county",
      "category": "Transit",
      "h1_title": "Roosevelt Area Apartments in King County",
      "h2_subtitle": "Explore Watercrest's offerings of Roosevelt area apartments in King County, where comfort meets convenience amidst a tranquil setting.",
      "page_copy": "Watercrest presents a unique opportunity for those searching for apartments near the Roosevelt area in King County. Nestled in Lake Forest Park, our community combines the serenity of suburban life with the vibrancy of city proximity.\n\nResidents enjoy spacious apartments with modern amenities such as dishwashers, private patios or balconies, and the comfort of a sauna. Our on-site maintenance and elevators ensure a hassle-free living experience. Located conveniently near the Roosevelt area, Watercrest connects you easily to the heart of King County's activities while providing a peaceful home environment.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Roosevelt Area Apartments in King County",
      "seo_description": "Discover Watercrest's Roosevelt area apartments in King County, offering modern amenities in a tranquil setting.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167098",
      "source": "generator",
      "page_item_url": "northgate-area-transit-friendly-apartments",
      "search_query": "northgate area transit-friendly apartments",
      "category": "Transit",
      "h1_title": "Transit-Friendly Apartments Near Northgate",
      "h2_subtitle": "Watercrest features transit-friendly apartments conveniently located near the Northgate area, perfect for seamless commutes.",
      "page_copy": "Strategically located in Lake Forest Park, Watercrest offers transit-friendly apartments near the Northgate area, ideal for those who value easy commuting. Our community ensures a lifestyle of convenience with close proximity to public transportation options.\n\nThe apartments boast modern amenities like private patios or balconies, dishwashers, and a relaxing sauna. With on-site maintenance and elevators, residents can enjoy a stress-free living experience. Watercrest couples these features with excellent connectivity, making it a prime choice for those seeking both comfort and accessibility.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Transit-Friendly Apts Near Northgate",
      "seo_description": "Watercrest provides transit-friendly apartments near Northgate with modern amenities and easy access to transportation.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "bobbi@repli360.com"
    },
    {
      "ID": "custom_pixel_id",
      "type": "STRING",
      "value": "1035508496598043"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "11307903003"
    },
    {
      "ID": "custom_text_us_url",
      "type": "STRING",
      "value": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=2067095440"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-TRWV5WQG"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 1"
    },
    {
      "ID": "custom_rentgrata_token",
      "type": "STRING",
      "value": "2ede0b55-e434-4a0d-8ca3-c16d2eee5dc1"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Preferred"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_pricing_verbiage",
      "type": "STRING",
      "value": "<strong>Featuring all-in-pricing.</strong> One total price, no hidden fees - just full transparency. With everything clearly listed so you can budget with certainty. Customize by adding parking, animals, and more."
    },
    {
      "ID": "custom_rentcafe_chatbot",
      "type": "STRING",
      "value": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/1721ecff-54e2-48e5-8c86-86ef8e481dbf/app.js?property=1721ecff-54e2-48e5-8c86-86ef8e481dbf&propertyName=Watercrest&channelUuid=c248f1ca-8dac-11ec-afb4-42010aa42b&buttonbgcolor=012345\" defer></script>"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "2429280200"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IlJta3JGdk5WQlhJQ0NHc0M4WlQvS2c9PSIsInZhbHVlIjoiRnc0SWRoYytET0wzczJ5UDE3c0l5UT09IiwibWFjIjoiNmM2ZTRiNGVjYTRjY2U2YjdhYzMwZDA5YzdhZjgwZGQwNWJlZjcyOTZhZTU0NTY5MTE1MjIyZmU1OGZhZDg1YSJ9"
    }
  ],
  "custom_csm": "bobbi@repli360.com",
  "custom_pixel_id": "1035508496598043",
  "custom_repli_id": "11307903003",
  "custom_text_us_url": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=2067095440",
  "custom_google_gtm_id": "GTM-TRWV5WQG",
  "custom_rollout_phase": "Phase 1",
  "custom_rentgrata_token": "2ede0b55-e434-4a0d-8ca3-c16d2eee5dc1",
  "custom_vibesites_theme": "Preferred",
  "custom_ads_subscription": "none",
  "custom_pricing_verbiage": "<strong>Featuring all-in-pricing.</strong> One total price, no hidden fees - just full transparency. With everything clearly listed so you can budget with certainty. Customize by adding parking, animals, and more.",
  "custom_rentcafe_chatbot": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/1721ecff-54e2-48e5-8c86-86ef8e481dbf/app.js?property=1721ecff-54e2-48e5-8c86-86ef8e481dbf&propertyName=Watercrest&channelUuid=c248f1ca-8dac-11ec-afb4-42010aa42b&buttonbgcolor=012345\" defer></script>",
  "custom_seo_subscription": "none",
  "custom_hubspot_company_id": "2429280200",
  "custom_social_subscription": "none",
  "custom_website_subscription": "turnkey",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IlJta3JGdk5WQlhJQ0NHc0M4WlQvS2c9PSIsInZhbHVlIjoiRnc0SWRoYytET0wzczJ5UDE3c0l5UT09IiwibWFjIjoiNmM2ZTRiNGVjYTRjY2U2YjdhYzMwZDA5YzdhZjgwZGQwNWJlZjcyOTZhZTU0NTY5MTE1MjIyZmU1OGZhZDg1YSJ9",
  "custom_audioeye_site_id": "c1f447ce-4c1c-4533-8ff1-ac31c8b3d8a9",
  "custom_audioeye_site_hash": "71ac6bcdf529ab91874bc0101c8678d9"
};

export const generatedAt = '2026-11-03T18:34:31.169Z';
